/**
 * Affiliate Training Page — /affiliate-training
 * Зөвхөн affiliate агентуудад зориулсан сургалтын хуудас.
 * Нэвтрэх: имэйл оруулах → үйлчилгээний нөхцөл зөвшөөрөх → агуулга харах
 */
import { useState, useEffect, useRef } from "react";
import { trpc } from "@/lib/trpc";
import { motion, AnimatePresence } from "framer-motion";
import {
  CheckCircle2,
  ChevronDown,
  ChevronRight,
  BookOpen,
  Globe,
  DollarSign,
  Users,
  FileText,
  Clock,
  AlertTriangle,
  Star,
  ArrowRight,
  Building2,
  Briefcase,
  GraduationCap,
  Plane,
  Shield,
  TrendingUp,
  MessageSquare,
  Share2,
  Link2,
  Home,
  Lock,
  Phone,
  LogOut,
} from "lucide-react";

/* ═══════════════════════════════════════════════════════════
   TERMS OF SERVICE CONTENT
═══════════════════════════════════════════════════════════ */
const TERMS_CONTENT = `
## Нэг. Ерөнхий заалт

United Dream Mongolia (цаашид "Компани" гэх) нь визийн зөвлөх үйлчилгээ үзүүлдэг байгууллага бөгөөд affiliate агентуудтай хамтран ажилладаг. Энэхүү үйлчилгээний нөхцөл нь affiliate агент болон Компанийн хоорондын харилцааг зохицуулна.

## Хоёр. Виз гарах баталгаа өгөхгүй байх

**2.1.** Affiliate агент нь үйлчлүүлэгчдэд виз заавал гарна гэсэн амлалт, баталгаа өгч **болохгүй**. Визийн шийдвэр нь зөвхөн тухайн улсын элчин сайдын яам, консулын газрын эрх мэдэлд байна.

**2.2.** Та зөвхөн Компанийн мэдээлэл, зааварчилгааны дагуу **зөвлөгөө болон мэдээлэл** өгөх эрхтэй. Визийн үр дүнг урьдчилан таамаглах, амлах нь хориглогдоно.

**2.3.** "99% виз гарна", "100% амжилттай" гэх мэт мэдэгдэл хийхийг хатуу хориглоно.

## Гурав. Орлогын баталгаа өгөхгүй байх

**3.1.** Компани нь affiliate агентад тодорхой хэмжээний орлого олно гэсэн **баталгаа, амлалт өгөхгүй**. Орлогын хэмжээ нь зөвхөн тухайн агентын идэвх, хичээл зүтгэл, маркетингийн чадвараас шалтгаална.

**3.2.** Платформд байгаа орлогын тооцоолуур болон жишээ тоонууд нь **лавлагааны зориулалттай** бөгөөд бодит орлогыг баталгаажуулахгүй.

**3.3.** Та бусдад "энэ хэмжээний орлого заавал олно" гэсэн амлалт өгч болохгүй.

## Дөрөв. Худал хуурмаг мэдээлэл өгөхгүй байх

**4.1.** Affiliate агент нь үйлчлүүлэгчдэд **худал, хуурмаг, буруу мэдээлэл** өгч болохгүй. Үүнд дараах зүйлс орно:
- Визийн шаардлага, бичиг баримтын талаар буруу мэдээлэл
- Боловсруулах хугацааны талаар буруу мэдэгдэл
- Компанийн үйлчилгээний нөхцөл, үнийн талаар буруу мэдээлэл
- Тухайн улсад байх боломжтой хугацааны талаар буруу мэдэгдэл

**3.2.** Мэдэхгүй зүйлийг "Мэдэхгүй байна, Компанийн зөвлөхтэй холбогдоорой" гэж шударгаар хэлэх нь зайлшгүй шаардлагатай.

## Дөрөв. Маркетинг, сурталчилгааны дүрэм

**4.1.** Компанийн зөвшөөрсөн маркетингийн материалыг чөлөөтэй хуваалцаж болно.

**4.2.** Өөрийн Facebook, Instagram болон бусад сошиал хаяг дээр Компанийн мэдээллийг нийтлэх зөвшөөрөлтэй. Гэхдээ нийтлэл нь үнэн зөв, буруу ойлголт үүсгэхгүй байх ёстой.

**4.3.** Компанийн нэр, лого, брэндийг буруу ашиглах, гуйвуулах нь хориглогдоно.

## Тав. Referral code болон комиссын нөхцөл

**5.1.** Affiliate агент бүр өвөрмөц **referral code** авна. Энэ кодыг үйлчлүүлэгчид "купон" хэлбэрээр ашиглуулна.

**5.2.** Үйлчлүүлэгч купон ашиглавал **5% хөнгөлөлт** авна.

**5.3.** Агент өөрөө онлайнаар гэрээ хийсэн тохиолдолд **20% комисс** авна (орлогын албан татвар хасагдана).

**5.4.** Үйлчлүүлэгч оффист очиж гэрээ байгуулсан тохиолдолд **10% комисс** авна.

**5.5.** Комисс нь зөвхөн **урьдчилгааны дүнгээс** тооцогдоно. Виз гарсны дараа авах үлдэгдэл төлбөрөөс комисс олгогдохгүй.

**5.6.** Комиссын хувь нь Компанийн шийдвэрээр урьдчилан мэдэгдэлгүйгээр өөрчлөгдөж болно.

## Зургаа. Нэмэлт орлого — шинэ агент элсүүлэх

**6.1.** Та шинэ affiliate агент элсүүлэх бүрт **₮20,000 нэмэлт урамшуулал** авна.

**6.2.** Шинэ агент нь энэхүү үйлчилгээний нөхцөлтэй танилцаж, зөвшөөрсний дараа л бүртгэгдэнэ.

## Долоо. Нууцлал

**7.1.** Үйлчлүүлэгчийн хувийн мэдээлэл (нэр, утас, имэйл, паспортын мэдээлэл) нь нууц бөгөөд гуравдагч этгээдэд дамжуулах хориглогдоно.

**7.2.** Компанийн дотоод мэдээлэл, үнийн бодлого, стратегийг бусдад задруулах хориглогдоно.

## Найм. Хариуцлага

**8.1.** Affiliate агент нь дээрх нөхцөлийг зөрчсөн тохиолдолд Компани нь гэрээг цуцлах, комиссыг зогсоох эрхтэй.

**8.2.** Зөрчлөөс үүдэлтэй хохирлыг агент хариуцна.

## Арав. Мэдээллийн үнэн зөв байдал

**10.1.** Платформд байгаа мэдээлэл буруу, хуучирсан байж болно. Агент нь мэдээллийн үнэн зөв байдлыг шалгах үүрэгтэй.

**10.2.** Та өөрийгөө тухайн улсын цагаачлалын өмгөөлөгч, хуулийн зөвлөх гэж танилцуулж **болохгүй**. Зөвхөн визийн тайлбар, мэдээлэл өгч, referral code ашиглан борлуулалт олох зорилготой.

## Арван нэг. Нэвтрэх эрхийн нууцлал

**11.1.** Нэвтрэх нэр, нууц үгийг бусдад дамжуулах хориглогдоно.

**11.2.** Зөрчил гаргасан нөхцөлд платформд нэвтрэх эрхийг хязгаарлах буюу бүрэн хаах эрхийг Компани хадгалана.

## Арван хоёр. Агентийн гишүүнчлэлийн төлбөр

**12.1.** Affiliate агентийн гишүүнчлэлийн төлбөр **буцаагдахгүй**. Төлбөр хийснээр та энэхүү нөхцлийг бүрэн хүлээн зөвшөөрсөн гэж тооцогдоно.

**12.2.** Ямар ч шалтгаанаар гишүүнчлэлийн төлбөрийг буцаан олгохгүй.

## Арван гурав. Нөхцөл өөрчлөгдөх эрх

**13.1.** Компани нь энэхүү нөхцлийг урьдчилан мэдэгдэлгүйгээр өөрчлөх эрхтэй. Өөрчлөлт нь платформд нийтлэгдсэн өдрөөс хүчин төгөлдөр болно.

## Арван дөрөв. Нөхцөл зөвшөөрөх

Доорх "Зөвшөөрч байна" товчийг дарснаар та энэхүү нөхцөлтэй бүрэн танилцаж, зөвшөөрсөн гэж тооцогдоно. Зөвшөөрсний баталгааг таны имэйл хаягт илгээнэ.
`;

/* ═══════════════════════════════════════════════════════════
   VISA DATA
═══════════════════════════════════════════════════════════ */
interface VisaInfo {
  country: string;
  flag: string;
  visas: {
    name: string;
    type: "immigrant" | "non-immigrant";
    category: "travel" | "study" | "work";
    description: string;
    duration: string;
    stayDuration: string;
    processingTime: string;
    bankBalance: string;
    steps: string[];
    documents: string[];
    afterOptions: string[];
    notes: string[];
  }[];
}

const VISA_DATA: VisaInfo[] = [
  {
    country: "АНУ",
    flag: "🇺🇸",
    visas: [
      {
        name: "B1/B2 — Аялалын виз",
        type: "non-immigrant",
        category: "travel",
        description:
          "АНУ-д аялал, бизнес, эмнэлгийн зорилгоор зочлоход зориулагдсан виз. ⚠️ 2026 оноос шинэ шаардлага: Виз олгогдсон ч АНУ-д зөвхөн 1 сар байж болно. Мөн $10,000-$15,000 барьцааны мөнгө (bond) шаардлагатай болсон.",
        duration: "1 сар (2026 оноос өөрчлөгдсөн)",
        stayDuration: "Нэг удаа 1 сар хүртэл",
        processingTime: "Ярилцлагын дараа шууд шийдвэр (ихэнх тохиолдолд)",
        bankBalance:
          "Тогтмол шаардлага байхгүй. Гэхдээ санхүүгийн чадавхийг нотлох баримт шаардлагтай. Аялалын зардаагаа бүрэн санхүүжүүлэх чадвартайг харуулах хэрэгтэй.",
        steps: [
          "DS-160 анкет бөглөх (онлайн, нарийн бөглөх шаардлагтай)",
          "Визийн хураамж $185 төлөх",
          "Бондын баримт бөлдөх (шинэ шаардлага)",
          "Ярилцлагын цаг авах (Улаанбаатарт АНУ-ын элчин сайдын яам)",
          "Ярилцлагад оролцох",
          "Паспорт хүлээн авах (ихэнхдээ 3-5 ажлын өдөр)",
        ],
        documents: [
          "Хүчинтэй паспорт (6 сараас дээш хугацаатай)",
          "DS-160 анкетийн баталгаажуулалтын хуудас",
          "Визийн хураамж төлсөн баримт",
          "Бондын баримт (шинэ шаардлага)",
          "Ярилцлагын цагийн баримт",
          "Гэрийн зураг (2x2 инч, цагаан дэвсгэртэй)",
          "Ажлын газрын тодорхойлолт / Оюутны тодорхойлолт",
          "Банкны хуулга (сүүлийн 3-6 сарын)",
          "Газар, орон сууцны гэрчиглэлэ",
          "Гэр бүлийн бүрэлдэхүүний гэрчиглэл",
          "Аялалын тийз / зочид буудлын захиалга (заавал биш)",
        ],
        afterOptions: [
          "B2 визтэй байхадаа F-1 оюутны визэнд шилжих боломжтой (Change of Status)",
          "Аялалын визэнд байхадаа их сургуульд элсэлт авч, оюутны визэнд шилжих хүсэлт гаргаж болно",
          "Гэр бүлийн гишүүн АНУ-д байгаа бол тэдэнтэй уулзах боломжтой",
        ],
        notes: [
          "⚠️ Шинэ шаардлага (2026): Виз олгогдсон ч АНУ-д зөвхөн 1 сар байж болно. Мөн $10,000-$15,000 барьцааны мөнгө (bond) шаардлагатай болсон.",
          "DS-160 анкетийг буруу, алдаатай, эсвэл логикгүй бөглөвөл шууд татгалзалд хүргэнэ",
          "Зорилгоо буруу тодорхойлох нь татгалзалын гол шалтгаан",
          "Өмнө нь татгалзал авсан бол заавал мэдэгдэх шаардлагтай",
          "Ярилцлагад Монгол хэлний орчуулагч байдаг",
        ],
      },
      {
        name: "F-1 — Оюутны виз",
        type: "non-immigrant",
        category: "study",
        description:
          "АНУ-ын SEVIS-д бүртгэлтэй сургуульд суралцахад зориулагдсан виз. Хэлний курс, коллеж, их сургуулийн аль алинд хамаарна.",
        duration: "Сургалтын хугацаанд + 60 хоног",
        stayDuration: "Сургалтын хугацаанд (D/S — Duration of Status)",
        processingTime: "Ярилцлагын дараа 3-5 ажлын өдөр",
        bankBalance:
          "Нэг жилийн сургалтын болон амьдралын зардлыг бүрэн санхүүжүүлэх чадвартайг нотлох шаардлагатай. Ихэнхдээ $15,000–$30,000+ харуулах хэрэгтэй.",
        steps: [
          "Сургуульд элсэлт авах (I-20 маягт авах)",
          "SEVIS хураамж $350 төлөх",
          "DS-160 анкет бөглөх",
          "Визийн хураамж $185 төлөх",
          "Ярилцлагын цаг авах",
          "Ярилцлагад оролцох",
          "Паспорт хүлээн авах",
        ],
        documents: [
          "I-20 маягт (сургуулиас олгосон)",
          "SEVIS хураамж төлсөн баримт (I-901)",
          "Хүчинтэй паспорт",
          "DS-160 баталгаажуулалт",
          "Визийн хураамж баримт",
          "Гэрийн зураг",
          "Банкны хуулга (нэг жилийн зардлыг харуулсан)",
          "Сургалтын хөтөлбөрийн мэдээлэл",
          "Монголд буцах хүчин зүйлсийн нотлох баримт (ажил, гэр бүл гэх мэт)",
        ],
        afterOptions: [
          "OPT (Optional Practical Training): Төгссөний дараа 12 сар (STEM мэргэжлийн хувьд 36 сар) АНУ-д ажиллах боломж",
          "CPT (Curricular Practical Training): Сургалтын явцад ажиллах боломж",
          "H-1B ажлын виз: Ажил олгогч ивээн тэтгэсэн тохиолдолд байнгын ажлын виз авах боломж",
          "EB-2/EB-3: Ажлын байнгын оршин суух (Green Card) авах зам",
        ],
        notes: [
          "Сургуулийн сонголт чухал — SEVIS-д бүртгэлтэй байх шаардлагатай",
          "Монголд буцах хүчин зүйлс байгааг нотлох нь маш чухал",
          "Хэлний мэдлэг шаардлагагүй (хэлний сургуульд явах тохиолдолд)",
          "Ажиллах зөвшөөрөл хязгаарлагдмал (7 цаг/7 хоног кампус дотор)",
        ],
      },
    ],
  },
  {
    country: "Австрали",
    flag: "🇦🇺",
    visas: [
      {
        name: "Subclass 600 — Аялалын виз",
        type: "non-immigrant",
        category: "travel",
        description:
          "Австралид аялал, гэр бүлийн зочлолт, бизнесийн зорилгоор зочлоход зориулагдсан виз.",
        duration: "1 жил хүртэл (олон удаа орох боломжтой)",
        stayDuration: "Нэг удаа 3 сар хүртэл",
        processingTime: "2-8 долоо хоног (онлайн хүсэлт)",
        bankBalance:
          "Аялалын бүх зардлыг санхүүжүүлэх чадвартайг нотлох шаардлагатай. Тогтмол дүн байхгүй ч $5,000–$10,000+ харуулах нь ашигтай.",
        steps: [
          "ImmiAccount бүртгэл үүсгэх",
          "Онлайн хүсэлт гаргах (Form 1419)",
          "Бичиг баримт оруулах",
          "Биометрик мэдээлэл өгөх (шаардлагатай тохиолдолд)",
          "Визийн хураамж $250 AUD төлөх (2024 оноос шинэчлэгдсэн)",
          "Шийдвэр хүлээх",
        ],
        documents: [
          "Хүчинтэй паспорт",
          "Гэрийн зураг",
          "Банкны хуулга",
          "Ажлын газрын тодорхойлолт",
          "Аялалын зорилгын тайлбар захидал",
          "Буцах тийзийн захиалга",
          "Зочид буудлын захиалга",
          "Эрүүл мэндийн даатгал",
        ],
        afterOptions: [
          "Аялалын визтэй байхдаа Австралийн сургуульд элсэлт авч оюутны визэнд шилжих боломжтой",
          "Working Holiday Visa (Subclass 417/462): 18-30 насны хүмүүст ажиллах боломж",
        ],
        notes: [
          "Онлайн хүсэлт гаргадаг тул ярилцлага байхгүй",
          "Шийдвэр имэйлээр ирдэг",
          "Виз зөвшөөрөгдсөн ч Австрали орох баталгаа биш",
        ],
      },
      {
        name: "Subclass 500 — Оюутны виз",
        type: "non-immigrant",
        category: "study",
        description:
          "Австралийн бүртгэлтэй сургуульд суралцахад зориулагдсан виз. ELICOS (хэлний курс)-аас эхлээд их сургуулийн хүртэл бүх түвшинд хамаарна.",
        duration: "Сургалтын хугацаанд + 2 сар",
        stayDuration: "Сургалтын хугацаанд",
        processingTime: "4-6 долоо хоног",
        bankBalance:
          "Нэг жилийн сургалтын болон амьдралын зардал: ойролцоогоор AUD 21,041 (2024 оны стандарт). Гэр бүлтэй бол нэмэлт дүн шаардагдана.",
        steps: [
          "CRICOS-д бүртгэлтэй сургуульд элсэлт авах",
          "CoE (Confirmation of Enrolment) авах",
          "Genuine Temporary Entrant (GTE) тайлбар бичих",
          "Онлайн хүсэлт гаргах",
          "Эрүүл мэндийн үзлэг (шаардлагатай тохиолдолд)",
          "Биометрик өгөх",
          "Шийдвэр хүлээх",
        ],
        documents: [
          "CoE (Confirmation of Enrolment)",
          "Хүчинтэй паспорт",
          "Банкны хуулга",
          "GTE тайлбар захидал",
          "Боловсролын гэрчилгээ",
          "Англи хэлний шалгалтын үр дүн (IELTS/PTE — шаардлагатай тохиолдолд)",
          "Эрүүл мэндийн даатгал (OSHC)",
        ],
        afterOptions: [
          "Post-Study Work Visa (Subclass 485): Төгссөний дараа 2-4 жил ажиллах боломж",
          "Skilled Migration: Мэргэжлийн ур чадвараар байнгын оршин суух авах боломж",
          "Employer Sponsored: Ажил олгогчийн ивээлтэйгээр байнгын оршин суух",
        ],
        notes: [
          "GTE (Genuine Temporary Entrant) тайлбар маш чухал — Монголд буцах хүсэл байгааг нотлох",
          "Ажиллах зөвшөөрөл: 7 хоногт 48 цаг хүртэл",
          "OSHC даатгал заавал шаардлагатай",
        ],
      },
    ],
  },
  {
    country: "Канад",
    flag: "🇨🇦",
    visas: [
      {
        name: "TRV — Аялалын виз",
        type: "non-immigrant",
        category: "travel",
        description:
          "Канадад аялал, гэр бүлийн зочлолт, бизнесийн зорилгоор зочлоход зориулагдсан виз. Temporary Resident Visa гэж нэрлэгддэг.",
        duration: "10 жил хүртэл (олон удаа орох)",
        stayDuration: "Нэг удаа 6 сар хүртэл",
        processingTime: "4-8 долоо хоног (онлайн хүсэлт)",
        bankBalance:
          "Тогтмол шаардлага байхгүй. Аялалын зардал + амьдралын зардлыг санхүүжүүлэх чадвартайг нотлох шаардлагатай. CAD 10,000+ харуулах нь ашигтай.",
        steps: [
          "IRCC онлайн бүртгэл үүсгэх",
          "Онлайн хүсэлт гаргах",
          "Биометрик мэдээлэл өгөх (Улаанбаатарт VAC-д)",
          "Бичиг баримт оруулах",
          "Визийн хураамж CAD 100 төлөх",
          "Шийдвэр хүлээх",
        ],
        documents: [
          "Хүчинтэй паспорт",
          "Гэрийн зураг",
          "Банкны хуулга",
          "Ажлын газрын тодорхойлолт",
          "Аялалын зорилгын тайлбар захидал",
          "Буцах тийзийн захиалга",
          "Зочид буудлын захиалга",
          "Гэр бүлийн бүрэлдэхүүний гэрчилгээ",
        ],
        afterOptions: [
          "Аялалын визтэй байхдаа сургуульд элсэлт авч оюутны визэнд шилжих боломжтой",
          "Visitor Record авч байх хугацааг сунгах боломжтой",
        ],
        notes: [
          "Биометрик өгөх шаардлагатай (Улаанбаатарт VAC байдаг)",
          "Онлайн хүсэлт гаргадаг тул ярилцлага байхгүй",
          "Шийдвэр имэйлээр ирдэг",
        ],
      },
    ],
  },
  {
    country: "Ирланд",
    flag: "🇮🇪",
    visas: [
      {
        name: "Study Visa — Хэлний сургуулийн виз",
        type: "non-immigrant",
        category: "study",
        description:
          "Ирландад хэлний сургуульд суралцахад зориулагдсан виз. Ирландын хэлний сургуулиуд нь Европт хамгийн хямд, чанартай гэж тооцогддог.",
        duration: "Сургалтын хугацаанд",
        stayDuration: "Сургалтын хугацаанд (ихэнхдээ 6-12 сар)",
        processingTime: "6-8 долоо хоног",
        bankBalance:
          "Сургалтын төлбөр + амьдралын зардал бүрэн байх шаардлагатай. Ойролцоогоор €7,000–€15,000+ (сургалтын хугацаанаас хамаарч).",
        steps: [
          "Ирландын хэлний сургуульд элсэлт авах",
          "Сургуулийн хүлээн авах захидал авах",
          "Онлайн хүсэлт гаргах (AVATS систем)",
          "Визийн хураамж €60 төлөх",
          "Бичиг баримт бэлдэх",
          "Ирландын элчин сайдын яамд хүсэлт илгээх",
          "Шийдвэр хүлээх",
        ],
        documents: [
          "Хүчинтэй паспорт",
          "Сургуулийн хүлээн авах захидал",
          "Сургалтын төлбөр төлсөн баримт",
          "Банкны хуулга",
          "Аялалын даатгал",
          "Амьдрах газрын нотлох баримт",
          "Боловсролын гэрчилгээ",
          "Ажлын туршлагын баримт (байгаа бол)",
          "Гэрийн зураг",
        ],
        afterOptions: [
          "Хэлний сургуулийн дараа их сургуульд шилжих боломжтой",
          "Critical Skills Employment Permit: Мэргэжлийн ажлын зөвшөөрөл авах боломж",
          "General Employment Permit: Ажил олгогчийн ивээлтэйгээр ажиллах боломж",
          "EU Blue Card: Өндөр мэргэжлийн ажилтнуудад зориулсан байнгын оршин суух",
          "Ирланд иргэншил: 5 жил байнга оршин суусны дараа хүсэлт гаргах боломжтой",
        ],
        notes: [
          "Ирланд нь Шенгений бүсэд ороогүй тул тусдаа виз шаардлагатай",
          "Ирландаас Шенгений бүсэд зочлоход тусдаа Шенгений виз хэрэгтэй",
          "Ажиллах зөвшөөрөл: 7 хоногт 20 цаг хүртэл (сургалтын явцад)",
          "IELTS шаардлагагүй (хэлний сургуульд явах тохиолдолд)",
        ],
      },
    ],
  },
  {
    country: "Чех",
    flag: "🇨🇿",
    visas: [
      {
        name: "Урт хугацааны ажлын зөвшөөрөл",
        type: "immigrant",
        category: "work",
        description:
          "Чехийн ажил олгогчтой гэрээ байгуулж, Чехт хууль ёсоор ажиллах зөвшөөрөл. Монголчуудын хувьд хамгийн хүртээмжтэй Европын ажлын виз.",
        duration: "3 сар–2 жил (сунгах боломжтой)",
        stayDuration: "Зөвшөөрлийн хугацаанд",
        processingTime: "3-6 сар",
        bankBalance:
          "Тогтмол шаардлага байхгүй. Ажлын гэрээ байгаа тул санхүүгийн нотлох баримт бага шаардагддаг.",
        steps: [
          "Чехийн ажил олгогчтой гэрээ байгуулах",
          "Ажлын зөвшөөрлийн хүсэлт гаргах (Чехийн хөдөлмөрийн газарт)",
          "Визийн хүсэлт гаргах (Чехийн элчин сайдын яамд)",
          "Бичиг баримт бэлдэх, нотариатаар баталгаажуулах",
          "Эрүүл мэндийн үзлэг",
          "Шийдвэр хүлээх",
          "Чехт ирсний дараа бүртгэл хийх",
        ],
        documents: [
          "Хүчинтэй паспорт",
          "Ажлын гэрээ (Чехийн ажил олгогчтой)",
          "Боловсролын дипломын нотариатаар баталгаажуулсан хуулбар",
          "Эрүүл мэндийн даатгал",
          "Амьдрах газрын нотлох баримт (Чехт)",
          "Гэмт хэргийн тодорхойлолт (Монголоос)",
          "Биометрик зураг",
        ],
        afterOptions: [
          "Ажлын зөвшөөрлийг сунгах боломжтой",
          "2 жил ажилласны дараа байнгын оршин суух (Permanent Residency) хүсэлт гаргах боломжтой",
          "5 жил байнга оршин суусны дараа Чехийн иргэншил авах боломжтой",
          "Чехт байхдаа Шенгений бүсийн 26 улсад чөлөөтэй зорчих боломжтой",
          "Гэр бүлийн гишүүдийг дагуулах боломжтой (Family Reunification)",
        ],
        notes: [
          "Чех нь Шенгений бүсэд орно — Чехийн визтэй 26 улсад зорчих боломжтой",
          "Монголчуудын хувьд хамгийн амжилттай ажлын визний зам",
          "18-45 насны хүмүүст хамгийн тохиромжтой",
          "Гэмт хэргийн тодорхойлолт Монгол болон Чехийн хоёуланд шаардагдана",
        ],
      },
    ],
  },
  {
    country: "Шенген (45 улс)",
    flag: "🇪🇺",
    visas: [
      {
        name: "C категори — Аялалын виз",
        type: "non-immigrant",
        category: "travel",
        description:
          "Шенгений бүсийн 26 улсад аялахад зориулагдсан виз. Нэг визээр 26 улсад чөлөөтэй зорчих боломжтой.",
        duration: "1-5 жил (олон удаа орох боломжтой)",
        stayDuration: "180 хоногт 90 хоног хүртэл",
        processingTime: "2-4 долоо хоног",
        bankBalance:
          "Өдөрт €50–€100 харуулах нь стандарт. Нийт аялалын хугацаанд хангалттай санхүүгийн баталгаа шаардлагатай.",
        steps: [
          "Аялах улсаа сонгох (хамгийн удаан байх улс эсвэл эхний орох улс)",
          "Тухайн улсын элчин сайдын яам/визийн төвд хүсэлт гаргах",
          "Биометрик мэдээлэл өгөх",
          "Бичиг баримт бэлдэх",
          "Визийн хураамж €80 төлөх",
          "Шийдвэр хүлээх",
        ],
        documents: [
          "Хүчинтэй паспорт",
          "Гэрийн зураг (Шенгений стандарт)",
          "Банкны хуулга",
          "Аялалын даатгал (€30,000+ хамгаалалттай)",
          "Тийзийн захиалга",
          "Зочид буудлын захиалга",
          "Ажлын газрын тодорхойлолт",
          "Аялалын зорилгын тайлбар захидал",
        ],
        afterOptions: [
          "Аялалын визтэй байхдаа Европын сургуульд элсэлт авч оюутны визэнд шилжих боломжтой",
          "Зарим Шенгений улс Working Holiday Visa олгодог",
        ],
        notes: [
          "90/180 дүрэм: 180 хоногт 90 хоногоос илүү байж болохгүй",
          "Шенгений бүсийн улсуудад хилийн шалгалт байхгүй",
          "Монгол улс Шенгений визийн хэрэгцээтэй улсад орно",
        ],
      },
    ],
  },
  {
    country: "Шинэ Зеланд",
    flag: "🇳🇿",
    visas: [
      {
        name: "Visitor Visa — Аяллын виз",
        type: "non-immigrant",
        category: "travel",
        description:
          "Шинэ Зеланд аялал, гэр бүлийн зочлолт, бизнесийн зорилгоор зочлоход зориулагдсан виз. Онлайнаар хүсэлт гаргах боломжтой.",
        duration: "9 сар хүртэл",
        stayDuration: "9 сар хүртэл",
        processingTime: "4-6 долоо хоног (онлайн хүсэлт)",
        bankBalance:
          "Аялалын бүх зардлыг хариуцах чадвартайгаа нотлох шаардлагатай. Ойролцоогоор $3,000–5,000 харуулах нь ашигтай.",
        steps: [
          "Immigration New Zealand вебсайтаар онлайн хүсэлт гаргах",
          "Бичиг баримт оруулах",
          "Визийн хураамж NZD 246 төлөх",
          "Шийдвэр хүлээх",
        ],
        documents: [
          "Хүчинтэй паспорт",
          "Банкны хуулга (сүүлийн 3 сарын)",
          "Ажлын газрын тодорхойлолт / Оюутны тодорхойлолт",
          "Аялалын тийз / зочид буудлын захиалга",
          "Аяллын даатгал",
          "Монголд буцах хүчин зүйлсийн нотлох баримт",
        ],
        afterOptions: [
          "Аяллын визтэй байхадаа сургуульд элсэлт авч оюутны визэнд шилжих боломж",
          "Working Holiday Visa (18-30 настай хүмүүст): ажиллах боломжтой виз",
        ],
        notes: [
          "Онлайн хүсэлт гаргах боломжтой — элчин сайдын яаманд явах шаардлагагүй",
          "Англи хэлний мэдлэг шаардахгүй боловч ашигтай",
          "Монголд буцах хүчин зүйлс харуулах нь чухал",
        ],
      },
      {
        name: "Student Visa — Сургалтын виз",
        type: "non-immigrant",
        category: "study",
        description:
          "Шинэ Зеландын бүртгэлтэй сургуульд 3 сараас дээш суралцахад зориулагдсан виз. Хэлний курс, коллеж, их сургуульд хамаарна.",
        duration: "Сургалтын хугацаанд",
        stayDuration: "Сургалтын хугацаанд + 1 сар",
        processingTime: "4-8 долоо хоног",
        bankBalance:
          "Нэг жилийн сургалтын болон амьдралын зардлыг хариуцах чадвартайгаа нотлох шаардлагатай. Ихэндээ NZD 15,000+ харуулах нь ашигтай.",
        steps: [
          "Сургуульд элсэлт авах (хүлээн зөвшөөрлийн захидас авах)",
          "Immigration New Zealand вебсайтаар онлайн хүсэлт гаргах",
          "Визийн хураамж NZD 375 төлөх",
          "Бичиг баримт оруулах",
          "Шийдвэр хүлээх",
        ],
        documents: [
          "Хүчинтэй паспорт",
          "Сургуульд элсэлт авсан баталгаажлалын захидас (хүлээн зөвшөөрлийн захидас)",
          "Банкны хуулга",
          "Англи хэлний шалгалтын баримт (IELTS/TOEFL гэх мэт)",
          "Ажлын газрын тодорхойлолт / Оюутны тодорхойлолт",
          "Монголд буцах хүчин зүйлсийн нотлох баримт",
        ],
        afterOptions: [
          "Post Study Work Visa: Төгссөний дараа 1-3 жил ажиллах боломж",
          "Skilled Migrant Category: Байнгын оршин суух (Resident Visa) авах зам",
        ],
        notes: [
          "Англи хэлний шалгалт шаардлагатай (IELTS 5.5+)",
          "Сургалтын хугацаанд ажиллах боломжтой (7 цаг/7 хоног хүртэл)",
          "Монголд буцах хүчин зүйлс харуулах нь чухал",
        ],
      },
    ],
  },

];

/* ═══════════════════════════════════════════════════════════
   HELPER COMPONENTS
═══════════════════════════════════════════════════════════ */
function Badge({ children, color = "blue" }: { children: React.ReactNode; color?: "blue" | "green" | "amber" | "red" | "purple" }) {
  const colors = {
    blue: "bg-blue-100 text-blue-800 border-blue-200",
    green: "bg-emerald-100 text-emerald-800 border-emerald-200",
    amber: "bg-amber-100 text-amber-800 border-amber-200",
    red: "bg-red-100 text-red-800 border-red-200",
    purple: "bg-purple-100 text-purple-800 border-purple-200",
  };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${colors[color]}`}>
      {children}
    </span>
  );
}

function SectionHeader({ icon, title, subtitle }: { icon: React.ReactNode; title: string; subtitle?: string }) {
  return (
    <div className="flex items-start gap-4 mb-8">
      <div className="flex-shrink-0 w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center text-white shadow-lg">
        {icon}
      </div>
      <div>
        <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
        {subtitle && <p className="text-gray-500 mt-1">{subtitle}</p>}
      </div>
    </div>
  );
}

function AccordionItem({
  title,
  children,
  defaultOpen = false,
  badge,
}: {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  badge?: React.ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden mb-3">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-4 text-left bg-white hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-3">
          <span className="font-semibold text-gray-900">{title}</span>
          {badge}
        </div>
        <ChevronDown
          className={`w-5 h-5 text-gray-400 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
            transition={{ duration: 0.25 }}
            className="overflow-hidden"
          >
            <div className="px-5 pb-5 pt-2 bg-gray-50 border-t border-gray-100">
              {children}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   TERMS MODAL
═══════════════════════════════════════════════════════════ */
function TermsModal({
  email,
  onAccept,
  onClose,
}: {
  email: string;
  onAccept: () => void;
  onClose: () => void;
}) {
  const [scrolled, setScrolled] = useState(false);
  const [accepting, setAccepting] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);
  const acceptTermsMutation = trpc.training.acceptTerms.useMutation();

  const handleScroll = () => {
    if (!scrollRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      setScrolled(true);
    }
  };

  const handleAccept = async () => {
    setAccepting(true);
    try {
      await acceptTermsMutation.mutateAsync({ email });
      onAccept();
    } catch {
      setAccepting(false);
    }
  };

  // Parse simple markdown-like content
  const renderTerms = (content: string) => {
    return content
      .trim()
      .split("\n")
      .map((line, i) => {
        if (line.startsWith("## ")) {
          return (
            <h3 key={i} className="text-lg font-bold text-gray-900 mt-6 mb-3 first:mt-0">
              {line.replace("## ", "")}
            </h3>
          );
        }
        if (line.startsWith("**") && line.endsWith("**")) {
          return (
            <p key={i} className="font-semibold text-gray-800 my-2">
              {line.replace(/\*\*/g, "")}
            </p>
          );
        }
        if (line.match(/^\*\*[\d.]+\*\*/)) {
          // Numbered bold items like **2.1.**
          const parts = line.split(/(\*\*[^*]+\*\*)/g);
          return (
            <p key={i} className="text-gray-700 my-1.5 leading-relaxed">
              {parts.map((part, j) =>
                part.startsWith("**") ? (
                  <strong key={j}>{part.replace(/\*\*/g, "")}</strong>
                ) : (
                  part
                )
              )}
            </p>
          );
        }
        if (line.startsWith("- ")) {
          return (
            <li key={i} className="text-gray-700 ml-4 my-0.5">
              {line.replace("- ", "")}
            </li>
          );
        }
        if (line.trim() === "") return <div key={i} className="h-1" />;
        return (
          <p key={i} className="text-gray-700 my-1.5 leading-relaxed">
            {line}
          </p>
        );
      });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl flex flex-col max-h-[90vh]"
      >
        {/* Header */}
        <div className="px-6 py-5 border-b border-gray-100 flex items-center gap-3">
          <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center">
            <Shield className="w-5 h-5 text-white" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-gray-900">Үйлчилгээний нөхцөл</h2>
            <p className="text-sm text-gray-500">Уншиж, зөвшөөрсний дараа агуулга нээгдэнэ</p>
          </div>
        </div>

        {/* Scrollable content */}
        <div
          ref={scrollRef}
          onScroll={handleScroll}
          className="flex-1 overflow-y-auto px-6 py-5"
        >
          <div className="prose prose-sm max-w-none">{renderTerms(TERMS_CONTENT)}</div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 rounded-b-2xl">
          {!scrolled && (
            <p className="text-sm text-amber-600 flex items-center gap-2 mb-3">
              <ChevronDown className="w-4 h-4 animate-bounce" />
              Доош гүйлгэж бүрэн уншина уу
            </p>
          )}
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2.5 border border-gray-300 rounded-xl text-gray-700 font-medium hover:bg-gray-100 transition-colors"
            >
              Буцах
            </button>
            <button
              onClick={handleAccept}
              disabled={!scrolled || accepting}
              className={`flex-1 px-4 py-2.5 rounded-xl font-semibold transition-all ${
                scrolled && !accepting
                  ? "bg-blue-600 text-white hover:bg-blue-700 shadow-md"
                  : "bg-gray-200 text-gray-400 cursor-not-allowed"
              }`}
            >
              {accepting ? "Хадгалж байна..." : "Зөвшөөрч байна ✓"}
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   EMAIL GATE
═══════════════════════════════════════════════════════════ */
function EmailGate({ onSuccess }: { onSuccess: (email: string) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const loginMutation = trpc.training.login.useMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    const trimmed = email.trim().toLowerCase();
    if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setError("Зөв имэйл хаяг оруулна уу");
      return;
    }
    if (!password) {
      setError("Нууц үгээ оруулна уу");
      return;
    }
    setLoading(true);
    try {
      await loginMutation.mutateAsync({ email: trimmed, password });
      onSuccess(trimmed);
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : "Алдаа гарлаа. Дахин оролдоно уу.";
      setError(msg.includes("UNAUTHORIZED") ? "Имэйл эсвэл нууц үг буруу байна" : msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-2xl shadow-xl mb-4">
            <BookOpen className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white">United Dream Mongolia</h1>
          <p className="text-blue-300 mt-1">Affiliate Агентуудын Сургалт</p>
        </div>

        {/* Card */}
        <div className="bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 p-8 shadow-2xl">
          <div className="flex items-center gap-2 mb-6">
            <Lock className="w-5 h-5 text-blue-300" />
            <p className="text-blue-200 text-sm">Зөвхөн бүртгэлтэй affiliate агентуудад нэвтрэх боломжтой</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-blue-100 mb-2">
                Имэйл хаяг
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tanii@email.com"
                className="w-full px-4 py-3 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-blue-100 mb-2">
                Нууц үг
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full px-4 py-3 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all"
              />
              {error && (
                <p className="mt-2 text-red-300 text-sm flex items-center gap-1">
                  <AlertTriangle className="w-4 h-4" />
                  {error}
                </p>
              )}
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-blue-600 hover:bg-blue-500 text-white font-semibold rounded-xl transition-all shadow-lg disabled:opacity-60 flex items-center justify-center gap-2"
            >
              {loading ? (
                "Нэвтэрч байна..."
              ) : (
                <>
                  Нэвтрэх <ArrowRight className="w-4 h-4" />
                </>
              )}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-white/10">
            <p className="text-white/50 text-xs text-center">
              Affiliate агент болоогүй бол{" "}
              <a href="/affiliate" className="text-blue-300 hover:text-blue-200 underline">
                энд дарж бүртгүүлнэ үү
              </a>
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   VISA CARD COMPONENT
═══════════════════════════════════════════════════════════ */
function VisaCard({ visa, countryFlag }: { visa: VisaInfo["visas"][0]; countryFlag: string }) {
  const categoryColors = {
    travel: "blue" as const,
    study: "green" as const,
    work: "amber" as const,
  };
  const categoryLabels = {
    travel: "Аялалын виз",
    study: "Оюутны виз",
    work: "Ажлын виз",
  };
  const typeLabel = visa.type === "immigrant" ? "Цагаачлалын виз" : "Цагаачлалын бус виз";
  const typeColor = visa.type === "immigrant" ? "purple" as const : "blue" as const;

  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="text-xl font-bold text-white">{visa.name}</h3>
            <p className="text-blue-200 text-sm mt-1">{visa.description}</p>
          </div>
          <div className="flex flex-col gap-1.5 flex-shrink-0">
            <Badge color={categoryColors[visa.category]}>{categoryLabels[visa.category]}</Badge>
            <Badge color={typeColor}>{typeLabel}</Badge>
          </div>
        </div>
      </div>

      {/* Quick stats */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-gray-100">
        {[
          { icon: <Clock className="w-4 h-4" />, label: "Визийн хугацаа", value: visa.duration },
          { icon: <Home className="w-4 h-4" />, label: "Байх хугацаа", value: visa.stayDuration },
          { icon: <TrendingUp className="w-4 h-4" />, label: "Боловсруулах", value: visa.processingTime },
          { icon: <DollarSign className="w-4 h-4" />, label: "Банкны данс", value: visa.bankBalance.split(".")[0] + "." },
        ].map((stat, i) => (
          <div key={i} className="bg-white px-4 py-3">
            <div className="flex items-center gap-1.5 text-blue-600 mb-1">
              {stat.icon}
              <span className="text-xs font-medium text-gray-500">{stat.label}</span>
            </div>
            <p className="text-sm font-semibold text-gray-900 leading-tight">{stat.value}</p>
          </div>
        ))}
      </div>

      {/* Details */}
      <div className="p-6 space-y-4">
        {/* Bank balance detail */}
        <div className="bg-blue-50 rounded-xl p-4 border border-blue-100">
          <div className="flex items-center gap-2 mb-2">
            <DollarSign className="w-4 h-4 text-blue-600" />
            <span className="font-semibold text-blue-900 text-sm">Банкны үлдэгдэл</span>
          </div>
          <p className="text-blue-800 text-sm leading-relaxed">{visa.bankBalance}</p>
        </div>

        {/* Steps */}
        <AccordionItem
          title={
            <span className="flex items-center gap-2">
              <ChevronRight className="w-4 h-4 text-blue-500" />
              Мэдүүлэх алхамууд
            </span>
          }
          defaultOpen
        >
          <ol className="space-y-2">
            {visa.steps.map((step, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 bg-blue-600 text-white text-xs font-bold rounded-full flex items-center justify-center mt-0.5">
                  {i + 1}
                </span>
                <span className="text-gray-700 text-sm">{step}</span>
              </li>
            ))}
          </ol>
        </AccordionItem>

        {/* Documents */}
        <AccordionItem
          title={
            <span className="flex items-center gap-2">
              <FileText className="w-4 h-4 text-green-500" />
              Бүрдүүлэх материал
            </span>
          }
        >
          <ul className="space-y-1.5">
            {visa.documents.map((doc, i) => (
              <li key={i} className="flex items-start gap-2">
                <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700 text-sm">{doc}</span>
              </li>
            ))}
          </ul>
        </AccordionItem>

        {/* After options */}
        <AccordionItem
          title={
            <span className="flex items-center gap-2">
              <TrendingUp className="w-4 h-4 text-purple-500" />
              {visa.type === "non-immigrant"
                ? "Аяллын/Оюутны визээр очоод хууль ёсоор үлдэх боломжууд"
                : "Байнгын оршин суух авах боломжууд"}
            </span>
          }
        >
          <ul className="space-y-2">
            {visa.afterOptions.map((option, i) => (
              <li key={i} className="flex items-start gap-2">
                <Star className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700 text-sm">{option}</span>
              </li>
            ))}
          </ul>
        </AccordionItem>

        {/* Notes */}
        {visa.notes.length > 0 && (
          <div className="bg-amber-50 rounded-xl p-4 border border-amber-100">
            <div className="flex items-center gap-2 mb-2">
              <AlertTriangle className="w-4 h-4 text-amber-600" />
              <span className="font-semibold text-amber-900 text-sm">Анхаарах зүйлс</span>
            </div>
            <ul className="space-y-1">
              {visa.notes.map((note, i) => (
                <li key={i} className="text-amber-800 text-sm flex items-start gap-2">
                  <span className="text-amber-500 mt-0.5">•</span>
                  {note}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   AGENT COST CALCULATOR
═══════════════════════════════════════════════════════════ */
const COST_DATA: Record<string, Record<string, { adults: number; children: number; sevis?: number; biometric?: number }>> = {
  "АНУ": {
    "Аялал (B-2)": { adults: 185, children: 185 },
    "Оюутан (F-1)": { adults: 185, children: 0, sevis: 350 },
  },
  "Австрали": {
    "Аялал (600)": { adults: 190, children: 95 },
    "Оюутан (500)": { adults: 710, children: 355 },
  },
  "Канад": {
    "Аялал": { adults: 100, children: 100, biometric: 85 },
    "Оюутан": { adults: 150, children: 150, biometric: 85 },
  },
  "Ирланд": {
    "Сургаль": { adults: 60, children: 60 },
  },
  "Чех": {
    "Дулгосрочный": { adults: 200, children: 200 },
  },
  "Шенген": {
    "C виз": { adults: 90, children: 45 },
  },
  "Шинэ Зеланд": {
    "Visitor Visa": { adults: 246, children: 246 },
    "Student Visa": { adults: 375, children: 375 },
  },
};

/* ═══════════════════════════════════════════════════════════
   SERVICE FEES SELECTOR
═══════════════════════════════════════════════════════════ */
const SERVICE_FEES: Record<string, Record<string, { fee: string; note: string }>> = {
  "🇺🇸 АНУ": {
    "Аялал (B-1/B-2)": { fee: "₮850,000", note: "Нэг төлбөр бүрэн төлнө" },
    "Сургалт (F-1) — урьдчилгаа": { fee: "$400", note: "Урьдчилгаа" },
    "Сургалт (F-1) — виз гарсны дараа": { fee: "$1,000", note: "Виз гарсны дараа" },
  },
  "🇦🇺 Австрали": {
    "Аялал (Tourist 600)": { fee: "₮850,000", note: "Нэг төлбөр бүрэн төлнө" },
    "Сургалт (Student 500)": { fee: "₮1,200,000", note: "Нэг төлбөр бүрэн төлнө" },
  },
  "🇨🇦 Канад": {
    "Аялал (Visitor)": { fee: "₮850,000", note: "Нэг төлбөр бүрэн төлнө" },
    "Сургалт (Student)": { fee: "₮1,200,000", note: "Нэг төлбөр бүрэн төлнө" },
  },
  "🇮🇪 Ирланд": {
    "Аялал": { fee: "₮850,000", note: "Нэг төлбөр бүрэн төлнө" },
    "Сургалт": { fee: "₮990,000", note: "Нэг төлбөр бүрэн төлнө" },
  },
  "🇳🇿 Шинэ Зеланд": {
    "Аялал (Visitor)": { fee: "₮850,000", note: "Нэг төлбөр бүрэн төлнө" },
    "Сургалт (Student)": { fee: "₮1,100,000", note: "Нэг төлбөр бүрэн төлнө" },
  },
  "🇨🇿 Чех (ажлын гэрээ)": {
    "Хөдөлмөрийн гэрээ — урьдчилгаа": { fee: "€800", note: "Урьдчилгаа" },
    "Хөдөлмөрийн гэрээ — дундах хуваарь": { fee: "€2,200", note: "3 хуваалт" },
  },
};

function ServiceFeesSelector() {
  const countries = Object.keys(SERVICE_FEES);
  const [selectedCountry, setSelectedCountry] = useState(countries[0]);
  const types = Object.keys(SERVICE_FEES[selectedCountry] || {});
  const [selectedType, setSelectedType] = useState(types[0]);
  const currentFee = SERVICE_FEES[selectedCountry]?.[selectedType];

  const handleCountryChange = (c: string) => {
    setSelectedCountry(c);
    const newTypes = Object.keys(SERVICE_FEES[c] || {});
    setSelectedType(newTypes[0] || "");
  };

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
      <h3 className="text-lg font-bold text-gray-900 mb-1">💰 Үйлчилгээний хөлс</h3>
      <p className="text-sm text-gray-500 mb-4">Улс, визний төрлөөр сонгоод дүн гарна</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-5">
        <div>
          <label className="text-xs font-semibold text-gray-600 mb-1.5 block">Улс</label>
          <select value={selectedCountry} onChange={(e) => handleCountryChange(e.target.value)}
            className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
            {countries.map((c) => <option key={c}>{c}</option>)}
          </select>
        </div>
        <div>
          <label className="text-xs font-semibold text-gray-600 mb-1.5 block">Визний төрол</label>
          <select value={selectedType} onChange={(e) => setSelectedType(e.target.value)}
            className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
            {types.map((t) => <option key={t}>{t}</option>)}
          </select>
        </div>
      </div>
      {currentFee && (
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-5 border border-blue-100">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">{selectedCountry} — {selectedType}</p>
              <p className="text-3xl font-black text-blue-700 mt-1">{currentFee.fee}</p>
              <p className="text-xs text-gray-500 mt-1">{currentFee.note}</p>
            </div>
            <div className="text-4xl">{selectedCountry.split(" ")[0]}</div>
          </div>
        </div>
      )}
      <div className="mt-3 bg-amber-50 border border-amber-100 rounded-xl p-3">
        <p className="text-xs text-amber-700 font-medium">⚠️ Комисс зөвхөн урьдчилгааны дүнгээс олгоно. Виз гарсны дараах дүнгээс комисс олгохгүй.</p>
      </div>
    </div>
  );
}

function AgentCostCalculator() {
  const [country, setCountry] = useState("АНУ");
  const [visaType, setVisaType] = useState("Аялал (B-2)");
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);

  const visaTypes = Object.keys(COST_DATA[country] || {});
  const currentVisa = COST_DATA[country]?.[visaType];

  const adultFee = (currentVisa?.adults || 0) * adults;
  const childFee = (currentVisa?.children || 0) * children;
  const sevisFee = currentVisa?.sevis ? currentVisa.sevis * adults : 0;
  const biometricFee = currentVisa?.biometric ? currentVisa.biometric * (adults + children) : 0;
  const total = adultFee + childFee + sevisFee + biometricFee;

  const handleCountryChange = (c: string) => {
    setCountry(c);
    const types = Object.keys(COST_DATA[c] || {});
    setVisaType(types[0] || "");
  };

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
      <h3 className="text-lg font-bold text-gray-900 mb-1">💰 Зардлын тооцоолуур</h3>
      <p className="text-sm text-gray-500 mb-5">Улс, визний төрөл, хүмүүсийн тооцсыг сонгоод визний хураамжийг тооцоолно.</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
        <div>
          <label className="text-xs font-semibold text-gray-600 mb-1.5 block">Улс</label>
          <select value={country} onChange={(e) => handleCountryChange(e.target.value)}
            className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
            {Object.keys(COST_DATA).map((c) => <option key={c}>{c}</option>)}
          </select>
        </div>
        <div>
          <label className="text-xs font-semibold text-gray-600 mb-1.5 block">Визний төрөл</label>
          <select value={visaType} onChange={(e) => setVisaType(e.target.value)}
            className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-400">
            {visaTypes.map((t) => <option key={t}>{t}</option>)}
          </select>
        </div>
        <div>
          <label className="text-xs font-semibold text-gray-600 mb-1.5 block">Томуул (хүмүүс)</label>
          <div className="flex items-center gap-2">
            <button onClick={() => setAdults(Math.max(1, adults - 1))} className="w-8 h-9 border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50 font-bold">-</button>
            <span className="flex-1 text-center font-bold text-gray-900">{adults}</span>
            <button onClick={() => setAdults(adults + 1)} className="w-8 h-9 border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50 font-bold">+</button>
          </div>
        </div>
        <div>
          <label className="text-xs font-semibold text-gray-600 mb-1.5 block">Хүүхэд</label>
          <div className="flex items-center gap-2">
            <button onClick={() => setChildren(Math.max(0, children - 1))} className="w-8 h-9 border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50 font-bold">-</button>
            <span className="flex-1 text-center font-bold text-gray-900">{children}</span>
            <button onClick={() => setChildren(children + 1)} className="w-8 h-9 border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50 font-bold">+</button>
          </div>
        </div>
      </div>
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-5 border border-blue-100">
        <div className="space-y-2 mb-4">
          {adults > 0 && <div className="flex justify-between text-sm"><span className="text-gray-600">Томуул хураамж ({adults}х)</span><span className="font-semibold">${adultFee}</span></div>}
          {children > 0 && <div className="flex justify-between text-sm"><span className="text-gray-600">Хүүхэд хураамж ({children}х)</span><span className="font-semibold">${childFee}</span></div>}
          {sevisFee > 0 && <div className="flex justify-between text-sm"><span className="text-gray-600">SEVIS хураамж</span><span className="font-semibold">${sevisFee}</span></div>}
          {biometricFee > 0 && <div className="flex justify-between text-sm"><span className="text-gray-600">Биометрик хураамж</span><span className="font-semibold">${biometricFee}</span></div>}
          <div className="border-t border-blue-200 pt-2 flex justify-between">
            <span className="font-bold text-gray-900">Нийт визний хураамж</span>
            <span className="font-black text-blue-700 text-lg">${total}</span>
          </div>
        </div>
        <p className="text-xs text-blue-600">ℹ️ Энэ зардалд манай уйлчилгээний хүргэлт оруулаагүй бөгөөд зөвхөн визний хураамж байна.</p>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   AGENT PROBABILITY CALCULATOR
═══════════════════════════════════════════════════════════ */
function AgentProbabilityCalc() {
  const [country, setCountry] = useState("АНУ");
  const [purpose, setPurpose] = useState("Аялал");
  const [employed, setEmployed] = useState<"Тийм" | "Үгүй" | "Оюутан" | "Тэтгэвэрт">("Тийм");
  const [hasInsurance, setHasInsurance] = useState(true);
  const [bankBalance, setBankBalance] = useState("Дундаж (хүрэлгэлтэй)");
  const [prevTravel, setPrevTravel] = useState("Байхгүй");
  const [familyAbroad, setFamilyAbroad] = useState("Байхгүй");
  const [familyStatus, setFamilyStatus] = useState("");
  const [age, setAge] = useState("26-45");
  const [maritalStatus, setMaritalStatus] = useState("Гэрлэсэн");
  const [hasProperty, setHasProperty] = useState(true);
  const [prevRejection, setPrevRejection] = useState("Байхгүй");
  const [income, setIncome] = useState("Дундаж (1-3 сая)");

  const BASE: Record<string, Record<string, number>> = {
    "АНУ": { "Аялал": 52, "Оюутан": 63 },
    "Австрали": { "Аялал": 60, "Оюутан": 70 },
    "Канад": { "Аялал": 58, "Оюутан": 68 },
    "Ирланд": { "Оюутан": 72 },
    "Чех": { "Ажил": 62 },
    "Шенген": { "Аялал": 65 },
    "Шинэ Зеланд": { "Аялал": 62, "Оюутан": 68 },
  };

  const purposes = Object.keys(BASE[country] || {});

  let prob = BASE[country]?.[purpose] ?? 60;

  // Employment
  if (employed === "Үгүй") prob -= 12;
  else if (employed === "Оюутан") prob -= 3;
  else if (employed === "Тэтгэвэрт") prob -= 2;

  // Insurance
  if (!hasInsurance) prob -= 6;

  // Bank balance
  if (bankBalance === "Маш сайн (5 сая+)") prob += 10;
  else if (bankBalance === "Сайн (3-5 сая)") prob += 6;
  else if (bankBalance === "Дундаж (1-3 сая)") prob += 0;
  else if (bankBalance === "Бага (500K-1 сая)") prob -= 8;
  else if (bankBalance === "Хүрэлгэлтгүй (<500K)") prob -= 15;

  // Previous travel
  if (prevTravel === "1-2 улс") prob += 4;
  else if (prevTravel === "3-5 улс") prob += 8;
  else if (prevTravel === "5+ улс") prob += 12;

  // Family abroad
  if (familyAbroad === "Тийм") {
    if (familyStatus === "Иргэн") prob += 5;
    else if (familyStatus === "Байнга оршин суугч") prob += 4;
    else if (familyStatus === "Оюутан") prob += 2;
    else if (familyStatus === "Баримтаа хүсэгч") prob -= 25;
    else if (familyStatus === "Хуулийн бус") prob -= 20;
  }

  // Age
  if (age === "18-25") prob -= 5;
  else if (age === "26-45") prob += 3;
  else if (age === "46-60") prob += 0;
  else if (age === "60+") prob -= 3;

  // Marital status
  if (maritalStatus === "Гэрлэсэн") prob += 4;
  else if (maritalStatus === "Салсан") prob -= 2;
  else if (maritalStatus === "Бэлэвсэн") prob += 1;

  // Property
  if (hasProperty) prob += 5;

  // Previous rejection
  if (prevRejection === "1 удаа") prob -= 10;
  else if (prevRejection === "2+ удаа") prob -= 20;

  // Income
  if (income === "Өндөр (5 сая+)") prob += 8;
  else if (income === "Дундаж (1-3 сая)") prob += 0;
  else if (income === "Бага (<1 сая)") prob -= 8;

  prob = Math.min(95, Math.max(10, prob));

  const color = prob >= 70 ? "text-green-600" : prob >= 50 ? "text-amber-600" : "text-red-600";
  const bgColor = prob >= 70 ? "bg-green-50 border-green-200" : prob >= 50 ? "bg-amber-50 border-amber-200" : "bg-red-50 border-red-200";
  const label = prob >= 70 ? "Маш сайн" : prob >= 50 ? "Дундаж" : "Хүндрэлтэй";

  const handleCountryChange = (c: string) => {
    setCountry(c);
    const ps = Object.keys(BASE[c] || {});
    setPurpose(ps[0] || "");
  };

  const selectClass = "w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white";
  const labelClass = "text-xs font-semibold text-gray-600 mb-1.5 block";
  const btnActive = "bg-blue-600 text-white";
  const btnInactive = "bg-gray-100 text-gray-600";
  const btnBase = "flex-1 py-2.5 rounded-xl text-sm font-medium transition-all";

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
      <h3 className="text-lg font-bold text-gray-900 mb-1">🎯 Виз гарах магадлал тооцоолуур</h3>
      <p className="text-sm text-gray-500 mb-5">Үйлчлүүлэгчийн нөхцөлд үндэслэн виз гарах магадлалыг тооцоолно. Зөвхөн лавлагааны зориулалттай.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
        {/* Country */}
        <div>
          <label className={labelClass}>🌍 Улс</label>
          <select value={country} onChange={(e) => handleCountryChange(e.target.value)} className={selectClass}>
            {Object.keys(BASE).map((c) => <option key={c}>{c}</option>)}
          </select>
        </div>
        {/* Purpose */}
        <div>
          <label className={labelClass}>🎯 Зорилго</label>
          <select value={purpose} onChange={(e) => setPurpose(e.target.value)} className={selectClass}>
            {purposes.map((p) => <option key={p}>{p}</option>)}
          </select>
        </div>
        {/* Age */}
        <div>
          <label className={labelClass}>🎂 Нас</label>
          <select value={age} onChange={(e) => setAge(e.target.value)} className={selectClass}>
            {["18-25", "26-45", "46-60", "60+"].map((a) => <option key={a}>{a}</option>)}
          </select>
        </div>
        {/* Marital status */}
        <div>
          <label className={labelClass}>💍 Гэрлэлтийн байдал</label>
          <select value={maritalStatus} onChange={(e) => setMaritalStatus(e.target.value)} className={selectClass}>
            {["Гэрлэсэн", "Гэрлээгүй", "Салсан", "Бэлэвсэн"].map((m) => <option key={m}>{m}</option>)}
          </select>
        </div>
        {/* Employment */}
        <div>
          <label className={labelClass}>💼 Ажил эрхлэлт</label>
          <select value={employed} onChange={(e) => setEmployed(e.target.value as any)} className={selectClass}>
            {["Тийм", "Үгүй", "Оюутан", "Тэтгэвэрт"].map((e) => <option key={e}>{e}</option>)}
          </select>
        </div>
        {/* Income */}
        <div>
          <label className={labelClass}>💰 Сарын орлого</label>
          <select value={income} onChange={(e) => setIncome(e.target.value)} className={selectClass}>
            {["Өндөр (5 сая+)", "Дундаж (1-3 сая)", "Бага (<1 сая)"].map((i) => <option key={i}>{i}</option>)}
          </select>
        </div>
        {/* Bank balance */}
        <div>
          <label className={labelClass}>🏦 Банкны үлдэгдэл</label>
          <select value={bankBalance} onChange={(e) => setBankBalance(e.target.value)} className={selectClass}>
            {["Маш сайн (5 сая+)", "Сайн (3-5 сая)", "Дундаж (1-3 сая)", "Бага (500K-1 сая)", "Хүрэлгэлтгүй (<500K)"].map((b) => <option key={b}>{b}</option>)}
          </select>
        </div>
        {/* Insurance */}
        <div>
          <label className={labelClass}>🛡️ Нийгмийн даатгал</label>
          <div className="flex gap-2">
            <button onClick={() => setHasInsurance(true)} className={`${btnBase} ${hasInsurance ? btnActive : btnInactive}`}>Тийм</button>
            <button onClick={() => setHasInsurance(false)} className={`${btnBase} ${!hasInsurance ? "bg-red-500 text-white" : btnInactive}`}>Үгүй</button>
          </div>
        </div>
        {/* Property */}
        <div>
          <label className={labelClass}>🏠 Үл хөдлөх хөрөнгө</label>
          <div className="flex gap-2">
            <button onClick={() => setHasProperty(true)} className={`${btnBase} ${hasProperty ? btnActive : btnInactive}`}>Байна</button>
            <button onClick={() => setHasProperty(false)} className={`${btnBase} ${!hasProperty ? "bg-red-500 text-white" : btnInactive}`}>Байхгүй</button>
          </div>
        </div>
        {/* Previous travel */}
        <div>
          <label className={labelClass}>✈️ Өмнөх аялал (5 жилд)</label>
          <select value={prevTravel} onChange={(e) => setPrevTravel(e.target.value)} className={selectClass}>
            {["Байхгүй", "1-2 улс", "3-5 улс", "5+ улс"].map((t) => <option key={t}>{t}</option>)}
          </select>
        </div>
        {/* Previous rejection */}
        <div>
          <label className={labelClass}>❌ Өмнөх татгалзал</label>
          <select value={prevRejection} onChange={(e) => setPrevRejection(e.target.value)} className={selectClass}>
            {["Байхгүй", "1 удаа", "2+ удаа"].map((r) => <option key={r}>{r}</option>)}
          </select>
        </div>
        {/* Family abroad */}
        <div>
          <label className={labelClass}>👨‍👩‍👧 Тус улсад хамаатан</label>
          <div className="flex gap-2">
            <button onClick={() => { setFamilyAbroad("Тийм"); setFamilyStatus(""); }} className={`${btnBase} ${familyAbroad === "Тийм" ? btnActive : btnInactive}`}>Тийм</button>
            <button onClick={() => { setFamilyAbroad("Байхгүй"); setFamilyStatus(""); }} className={`${btnBase} ${familyAbroad === "Байхгүй" ? btnActive : btnInactive}`}>Байхгүй</button>
          </div>
        </div>
        {familyAbroad === "Тийм" && (
          <div>
            <label className={labelClass}>📋 Хамаатны статус</label>
            <select value={familyStatus} onChange={(e) => setFamilyStatus(e.target.value)} className={selectClass}>
              <option value="">Сонгоно уу</option>
              {["Иргэн", "Байнга оршин суугч", "Оюутан", "Баримтаа хүсэгч", "Хуулийн бус"].map((s) => <option key={s}>{s}</option>)}
            </select>
          </div>
        )}
      </div>

      {/* Result */}
      <div className={`rounded-2xl border p-5 ${bgColor}`}>
        <div className="flex items-center justify-between mb-3">
          <div>
            <p className="text-sm font-medium text-gray-700">Виз гарах магадлал</p>
            <p className={`text-4xl font-black ${color}`}>{prob}%</p>
            <p className={`text-sm font-semibold ${color}`}>{label}</p>
          </div>
          <div className="w-24 h-24 relative">
            <svg viewBox="0 0 36 36" className="w-full h-full -rotate-90">
              <circle cx="18" cy="18" r="15.9" fill="none" stroke="#e5e7eb" strokeWidth="3" />
              <circle cx="18" cy="18" r="15.9" fill="none"
                stroke={prob >= 70 ? "#16a34a" : prob >= 50 ? "#d97706" : "#dc2626"}
                strokeWidth="3"
                strokeDasharray={`${prob} ${100 - prob}`}
                strokeLinecap="round"
              />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className={`text-sm font-black ${color}`}>{prob}%</span>
            </div>
          </div>
        </div>
        <div className="bg-white/60 rounded-xl p-3">
          <p className="text-xs text-gray-700 leading-relaxed">
            {prob >= 70
              ? "Маш сайн нөхцөлд байна. Манай байгууллагаар дамжуулан амжилттай виз авах боломж өндөр байна."
              : prob >= 50
              ? "Дундаж магадлалтай. Манай байгууллага адилтай нөхцөлтэй хүмүүст амжилттай туслаж ирсэн. Баримт бичгийг сайн бэлтгэснээр магадлал нэмэгдэнэ."
              : "Магадлал бага байна. Гэхдээ манайтай адилтай нөхцөлтэй олон хүн амжилттай виз авсан. Манай мэргэжлийн баг таны нөхцөлд тохирсон шийдэл гаргаж өгнө. Төв оффистой зөвлөгөө авахыг зөвлөж байна."}
          </p>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   MAIN TRAINING PAGE CONTENT
═══════════════════════════════════════════════════════════ */
function TrainingContent({ email, onLogout }: { email: string; onLogout: () => void }) {
  const [activeSection, setActiveSection] = useState<string>("dashboard");
  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteSent, setInviteSent] = useState(false);
  const [inviteLoading, setInviteLoading] = useState(false);
  const [inviteError, setInviteError] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [selectedVisas, setSelectedVisas] = useState<string[]>(["usa", "canada", "australia", "schengen"]);
  const [clientEmailSent, setClientEmailSent] = useState(false);
  const [clientEmailLoading, setClientEmailLoading] = useState(false);
  const [clientEmailError, setClientEmailError] = useState("");

  const { data: myStats } = trpc.training.getMyStats.useQuery({ email });
  const inviteMutation = trpc.training.inviteFriend.useMutation();
  const sendClientEmailMutation = trpc.affiliate.sendClientEmail.useMutation();

  const handleSendClientEmail = async () => {
    if (!clientEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(clientEmail)) {
      setClientEmailError("Зөв имэйл хаяг оруулна уу");
      return;
    }
    if (!myStats?.referralCode) {
      setClientEmailError("Referral code олдсонгүй");
      return;
    }
    setClientEmailLoading(true);
    setClientEmailError("");
    try {
      await sendClientEmailMutation.mutateAsync({
        clientEmail,
        agentReferralCode: myStats.referralCode,
        visaTypes: selectedVisas,
      });
      setClientEmailSent(true);
      setClientEmail("");
      setTimeout(() => setClientEmailSent(false), 3000);
    } catch {
      setClientEmailError("Мэйл явуулахад алдаа гарлаа. Дахин оролдоно уу.");
    } finally {
      setClientEmailLoading(false);
    }
  };

  const handleInvite = async () => {
    if (!inviteEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inviteEmail)) {
      setInviteError("Зөв имэйл хаяг оруулна уу");
      return;
    }
    setInviteLoading(true);
    setInviteError("");
    try {
      await inviteMutation.mutateAsync({
        fromEmail: email,
        fromName: myStats?.agentName || email,
        toEmail: inviteEmail,
      });
      setInviteSent(true);
      setInviteEmail("");
    } catch {
      setInviteError("Имэйл явуулахад алдаа гарлаа. Дахин оролдоно уу.");
    } finally {
      setInviteLoading(false);
    }
  };
  const [activeCountry, setActiveCountry] = useState<string>("АНУ");
  const visaOptions = [
    { id: "usa", label: "🇺🇸 АНУ" },
    { id: "canada", label: "🇨🇦 Канад" },
    { id: "australia", label: "🇦🇺 Австрали" },
    { id: "schengen", label: "🇪🇺 Шенген" },
  ];

  const sections = [
    { id: "dashboard", label: "Миний дашбоард", icon: <TrendingUp className="w-4 h-4" /> },
    { id: "company", label: "Байгууллага", icon: <Building2 className="w-4 h-4" /> },
    { id: "visa-basics", label: "Визний үндэс", icon: <Globe className="w-4 h-4" /> },
    { id: "visa-details", label: "Визний дэлгэрэнгүй", icon: <BookOpen className="w-4 h-4" /> },
    { id: "tools", label: "Визний хураамж, зардал", icon: <DollarSign className="w-4 h-4" /> },
    { id: "probability", label: "Виз гарах магадлал", icon: <TrendingUp className="w-4 h-4" /> },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top bar */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-40 shadow-sm">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-between h-14">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <BookOpen className="w-4 h-4 text-white" />
              </div>
              <span className="font-bold text-gray-900 hidden sm:block">Affiliate Сургалт</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-500 hidden sm:block">{email}</span>
              <a
                href="/"
                className="text-sm text-blue-600 hover:text-blue-700 flex items-center gap-1"
              >
                <Home className="w-4 h-4" />
                <span className="hidden sm:block">Нүүр хуудас</span>
              </a>
              <button
                onClick={onLogout}
                className="text-sm text-red-500 hover:text-red-600 flex items-center gap-1 border border-red-200 rounded-lg px-2 py-1 hover:bg-red-50 transition-colors"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:block">Гарах</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Welcome banner */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <h1 className="text-xl sm:text-2xl font-bold mb-1">
            Тавтай морилно уу! 👋
          </h1>
          <p className="text-blue-100 text-sm max-w-2xl mb-2">
            Энэ хуудас нь United Dream Mongolia-ийн affiliate агентуудад зориулсан бүрэн сургалтын материал юм.
          </p>
          <div className="bg-white/15 border border-white/30 rounded-xl px-4 py-2.5 inline-flex items-center gap-2">
            <span className="text-base">📚</span>
            <p className="text-white text-sm font-medium">Та бүрэн гүйцэд бүх зүйлтэй танилцана уу — доорх хэсгүүдийг дараалан уншиж, визийн мэдлэгээ гүнзгийрүүлнэ уу.</p>
          </div>
        </div>
      </div>

      {/* Telegram Group CTA Banner */}
      <div className="bg-gradient-to-r from-blue-500 to-blue-600">
        <div className="max-w-6xl mx-auto px-3 py-2.5">
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <span className="text-sm">📱</span>
              </div>
              <div>
                <p className="text-white font-bold text-sm">Телеграм группт нэгдээрэй!</p>
                <p className="text-blue-100 text-xs hidden sm:block">Онцгой санал, шинэ мэдээлэл, маркетингийн материалыг хамгийн түрүүнд авна</p>
              </div>
            </div>
            <a
              href="https://t.me/+zbaTs6bJ0hpkYjMx"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 bg-white text-blue-600 font-bold px-3 py-1.5 rounded-lg hover:bg-blue-50 transition-colors text-xs flex-shrink-0 shadow-sm"
            >
              <span className="text-sm">📱</span>
              Нэгдэх
            </a>
          </div>
        </div>
      </div>

      {/* Navigation tabs */}
      <div className="bg-white border-b border-gray-200 sticky top-14 z-30">
        <div className="max-w-6xl mx-auto px-2 sm:px-4">
          {/* Mobile: vertical stacked grid, Desktop: horizontal scroll */}
          <div className="hidden sm:flex gap-1 py-2 overflow-x-auto" style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}>
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => { setActiveSection(section.id); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                style={{ flexShrink: 0 }}
                className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all ${
                  activeSection === section.id
                    ? "bg-blue-600 text-white shadow-sm"
                    : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                <span className="flex-shrink-0">{section.icon}</span>
                <span>{section.label}</span>
              </button>
            ))}
          </div>
          {/* Mobile vertical menu */}
          <div className="sm:hidden grid grid-cols-2 gap-1 py-2">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => { setActiveSection(section.id); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                className={`flex items-center gap-1.5 px-2.5 py-2 rounded-lg text-xs font-medium transition-all ${
                  activeSection === section.id
                    ? "bg-blue-600 text-white shadow-sm"
                    : "text-gray-600 hover:bg-gray-100 bg-gray-50"
                }`}
              >
                <span className="flex-shrink-0">{section.icon}</span>
                <span className="truncate">{section.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-4 py-8">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeSection}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
          >
            {/* ── DASHBOARD ── */}
            {activeSection === "dashboard" && (
              <div className="space-y-6">
                {/* Header */}
                <div className="bg-gradient-to-br from-indigo-600 via-purple-600 to-blue-700 rounded-2xl p-6 text-white shadow-xl">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                    <div>
                      <p className="text-indigo-200 text-sm font-medium mb-1">Тавтай морилно уу!</p>
                      <h2 className="text-2xl font-bold">{myStats?.agentName || email}</h2>
                      <p className="text-indigo-200 text-sm mt-1">{email}</p>
                      <p className="text-indigo-300 text-xs mt-2 font-medium">✨ Таны ажлын талбар</p>
                    </div>
                    <div className="flex flex-col sm:items-end gap-2">
                      {myStats?.referralCode && (
                        <div className="bg-white/20 backdrop-blur rounded-xl px-4 py-2 text-center">
                          <p className="text-xs text-indigo-200">Таны referral код</p>
                          <p className="text-xl font-black tracking-widest cursor-pointer hover:text-indigo-100 transition-colors" onClick={() => {
                            navigator.clipboard.writeText(myStats.referralCode);
                            alert('Referral код хуулагдлаа!');
                          }}>{myStats.referralCode}</p>
                          <p className="text-xs text-indigo-300 mt-1">📋 дарж хуулах</p>
                        </div>
                      )}
                      <a
                        href="tel:+97680806633"
                        className="flex items-center gap-2 bg-green-500 hover:bg-green-400 text-white px-4 py-2.5 rounded-xl font-semibold text-sm transition-all shadow-lg"
                      >
                        <Phone className="w-4 h-4" />
                        Төв оффис: 8080-6633
                      </a>
                    </div>
                  </div>
                </div>

                {/* Stats grid */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Нийт хэрэглэгч", value: myStats?.usageCount ?? 0, icon: "👥", color: "bg-blue-50 border-blue-100" },
                    { label: "Баталгаажсан захиалга", value: myStats?.confirmedOrders ?? 0, icon: "✅", color: "bg-green-50 border-green-100" },
                    { label: "Нийт борлуулалт", value: myStats ? `₮${myStats.totalServiceFee.toLocaleString()}` : "₮0", icon: "📊", color: "bg-purple-50 border-purple-100" },
                    { label: "Таны комисс", value: myStats ? `₮${(myStats.totalCommission ?? myStats.estimatedCommission).toLocaleString()}` : "₮0", icon: "💰", color: "bg-amber-50 border-amber-100" },
                  ].map((s, i) => (
                    <div key={i} className={`${s.color} border rounded-2xl p-4 text-center`}>
                      <div className="text-2xl mb-1">{s.icon}</div>
                      <p className="text-lg font-bold text-gray-900">{s.value}</p>
                      <p className="text-xs text-gray-500 mt-0.5">{s.label}</p>
                    </div>
                  ))}
                </div>

                {/* Tier progress */}
                <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
                  <h3 className="text-lg font-bold text-gray-900 mb-4">🏆 Агентын зэрэглэл</h3>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6">
                    {[
                      { tier: "starter", label: "Starter", emoji: "🌱", threshold: "0", discount: "5%", color: "bg-gray-100 border-gray-200", activeColor: "bg-indigo-600 border-indigo-600 text-white" },
                      { tier: "pro", label: "Pro", emoji: "⚡", threshold: "20M+", discount: "10%", color: "bg-gray-100 border-gray-200", activeColor: "bg-blue-600 border-blue-600 text-white" },
                      { tier: "elite", label: "Elite", emoji: "💎", threshold: "30M+", discount: "15%", color: "bg-gray-100 border-gray-200", activeColor: "bg-purple-600 border-purple-600 text-white" },
                      { tier: "premier", label: "Premier", emoji: "👑", threshold: "40M+", discount: "15%", color: "bg-gray-100 border-gray-200", activeColor: "bg-amber-500 border-amber-500 text-white" },
                    ].map((t) => {
                      const isActive = myStats?.tier === t.tier;
                      return (
                        <div key={t.tier} className={`border-2 rounded-2xl p-3 text-center transition-all ${isActive ? t.activeColor : t.color}`}>
                          <div className="text-2xl mb-1">{t.emoji}</div>
                          <p className={`font-bold text-sm ${isActive ? "text-white" : "text-gray-900"}`}>{t.label}</p>
                          <p className={`text-xs mt-0.5 ${isActive ? "text-white/80" : "text-gray-500"}`}>{t.threshold}</p>
                          <div className={`mt-2 rounded-lg py-1 px-2 text-xs font-bold ${isActive ? "bg-white/20 text-white" : "bg-white text-gray-700"}`}>
                            {t.discount} хөнгөлөлт
                          </div>
                          {isActive && <div className="mt-1 text-xs font-semibold text-white/90">← Одоогийн</div>}
                        </div>
                      );
                    })}
                  </div>
                  <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl p-4 border border-indigo-100">
                    <p className="text-sm text-indigo-800 font-medium mb-1">📈 Зэрэглэл дэвших тусам орлого нэмэгдэнэ</p>
                    <p className="text-xs text-indigo-600 leading-relaxed">
                      Таны referral кодыг ашиглах хүмүүс нэмэгдэх тусам хөнгөлөлтийн хувь өснө — үйлчлүүлэгчид илүү их хөнгөлөлт авах тул таны код дахин дахин ашиглагдана.
                      Starter (5%) → Pro (10%) → Elite (15%) → Premier (15% + онцгой давуу эрх)
                    </p>
                  </div>
                </div>

                {/* Recent Sales Table */}
                {myStats && myStats.recentSales && myStats.recentSales.length > 0 && (
                  <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
                    <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <span>📋</span> Борлуулалтын түүх
                    </h3>
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="border-b border-gray-100">
                            <th className="text-left text-xs text-gray-500 font-medium pb-2">Үйлчилгээ</th>
                            <th className="text-left text-xs text-gray-500 font-medium pb-2">Төрөл</th>
                            <th className="text-right text-xs text-gray-500 font-medium pb-2">Дүн</th>
                            <th className="text-right text-xs text-gray-500 font-medium pb-2">Комисс</th>
                            <th className="text-right text-xs text-gray-500 font-medium pb-2">Төлөв</th>
                          </tr>
                        </thead>
                        <tbody>
                          {myStats.recentSales.map((sale, i) => (
                            <tr key={i} className="border-b border-gray-50 hover:bg-gray-50 transition-colors">
                              <td className="py-2.5 pr-2">
                                <p className="font-medium text-gray-900 text-xs leading-tight">{sale.visaName}</p>
                                <p className="text-gray-400 text-[10px] mt-0.5">{new Date(sale.createdAt).toLocaleDateString("mn-MN")}</p>
                              </td>
                              <td className="py-2.5 pr-2">
                                <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full ${
                                  sale.orderSource === "self" ? "bg-purple-100 text-purple-700" : "bg-blue-100 text-blue-700"
                                }`}>
                                  {sale.orderSource === "self" ? "Өөрөө" : "Биднээр"}
                                </span>
                              </td>
                              <td className="py-2.5 text-right text-gray-700 font-medium text-xs">{sale.totalPrice}</td>
                              <td className="py-2.5 text-right">
                                <span className={`font-bold text-xs ${
                                  sale.status === "confirmed" ? "text-green-600" :
                                  sale.status === "cancelled" ? "text-gray-400" : "text-amber-500"
                                }`}>
                                  {sale.status === "cancelled" ? "-" : `₮${sale.commissionAmount.toLocaleString()}`}
                                </span>
                                {sale.status !== "cancelled" && (
                                  <span className="text-gray-400 text-[10px] ml-1">({sale.commissionRate}%)</span>
                                )}
                              </td>
                              <td className="py-2.5 text-right">
                                <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full ${
                                  sale.status === "confirmed" ? "bg-green-100 text-green-700" :
                                  sale.status === "cancelled" ? "bg-red-100 text-red-700" :
                                  "bg-yellow-100 text-yellow-700"
                                }`}>
                                  {sale.status === "confirmed" ? "Баталгаажсан" :
                                   sale.status === "cancelled" ? "Цуцлагдсан" : "Хүлээгдэж байна"}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {myStats.recentSales.length === 10 && (
                      <p className="text-xs text-gray-400 text-center mt-3">Сүүлийн 10 борлуулалт харагдаж байна</p>
                    )}
                  </div>
                )}

                {/* Send Lead Email */}
                <div className="bg-white rounded-2xl border-2 border-blue-200 p-6 shadow-sm">
                  <div className="flex items-start justify-between mb-3">
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                        <span className="text-xl">✉️</span>
                        Lead-ээс мэйл явуулах
                      </h3>
                      <p className="text-sm text-gray-500 mt-0.5">Lead-ийн имэйл рүү визний мэдээлэл болон таны referral кодыг автоматаар явуулна</p>
                    </div>
                    <span className="bg-blue-100 text-blue-700 text-xs font-bold px-2 py-1 rounded-lg flex-shrink-0">Автомат</span>
                  </div>

                  <div className="bg-blue-50 border border-blue-100 rounded-xl p-3 mb-4">
                    <p className="text-xs text-blue-800 leading-relaxed">
                      📧 Lead таны имэйл хүлээн авснаар: <strong>АНУ, Канад, Австрали, Шенген</strong> визний мэдээлэл + маркетинг материал + таны referral кодоор <strong>5% хөнгөлөлт</strong> авах боломжийг автоматаар явуулна.
                    </p>
                  </div>

                  {clientEmailSent ? (
                    <div className="bg-green-50 border border-green-200 rounded-xl p-4 text-center">
                      <div className="text-3xl mb-2">✅</div>
                      <p className="font-semibold text-green-800">Мэйл амжилттай явлаа!</p>
                      <button
                        onClick={() => setClientEmailSent(false)}
                        className="mt-3 text-sm text-green-600 underline"
                      >
                        Дахин явуулах
                      </button>
                    </div>
                  ) : (
                    <div className="space-y-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Lead-ийн имэйл хаяг</label>
                        <input
                          type="email"
                          value={clientEmail}
                          onChange={(e) => { setClientEmail(e.target.value); setClientEmailError(""); }}
                          placeholder="lead@email.com"
                          className="w-full px-4 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Визний төрөл сонгох</label>
                        <div className="grid grid-cols-2 gap-2">
                          {visaOptions.map((opt) => (
                            <label
                              key={opt.id}
                              className={`flex items-center gap-2 p-3 rounded-xl border cursor-pointer transition-all ${
                                selectedVisas.includes(opt.id)
                                  ? "bg-blue-50 border-blue-400 text-blue-800"
                                  : "bg-gray-50 border-gray-200 text-gray-700 hover:border-gray-300"
                              }`}
                            >
                              <input
                                type="checkbox"
                                checked={selectedVisas.includes(opt.id)}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedVisas((prev) => [...prev, opt.id]);
                                  } else {
                                    setSelectedVisas((prev) => prev.filter((v) => v !== opt.id));
                                  }
                                }}
                                className="w-4 h-4 accent-blue-600"
                              />
                              <span className="text-sm font-medium">{opt.label}</span>
                            </label>
                          ))}
                        </div>
                      </div>

                      {clientEmailError && (
                        <p className="text-red-500 text-xs">{clientEmailError}</p>
                      )}

                      <button
                        onClick={handleSendClientEmail}
                        disabled={clientEmailLoading || selectedVisas.length === 0}
                        className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl text-sm transition-all disabled:opacity-60 flex items-center justify-center gap-2"
                      >
                        {clientEmailLoading ? (
                          <><span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> Явуулж байна...</>
                        ) : (
                          <>✉️ Мэйл явуулах</>
                        )}
                      </button>
                    </div>
                  )}
                </div>

                {/* Invite friend */}
                <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="text-lg font-bold text-gray-900">🤝 Найзаа урих</h3>
                    <div className="bg-amber-100 border border-amber-200 rounded-xl px-3 py-1.5 text-center">
                      <p className="text-xs text-amber-600 font-medium">Урамшуулал</p>
                      <p className="text-base font-black text-amber-700">₮20,000</p>
                    </div>
                  </div>
                  <div className="bg-amber-50 border border-amber-100 rounded-xl p-3 mb-4">
                    <p className="text-sm text-amber-800 font-medium">🌟 Шинэ агент бүртгүүлэх бүрт ₮20,000 нэмэлтэл урамшуулал авна!</p>
                    <p className="text-xs text-amber-600 mt-1">Найзынхаа имэйлийг оруулахад агентийн хуудасны линк болон агент болох хүслийг өдөөсөн бичвэр бүхий имэйл автоматаар очно. Тэдгээр бүртгүүлэх бүрт та ₮20,000 авна.</p>
                  </div>
                  {inviteSent ? (
                    <div className="bg-green-50 border border-green-200 rounded-xl p-4 text-center">
                      <div className="text-3xl mb-2">✅</div>
                      <p className="font-semibold text-green-800">Имэйл амжилттай явлаа!</p>
                      <button onClick={() => setInviteSent(false)} className="mt-3 text-sm text-green-600 underline">Дахин явуулах</button>
                    </div>
                  ) : (
                    <div className="flex gap-2">
                      <input
                        type="email"
                        value={inviteEmail}
                        onChange={(e) => { setInviteEmail(e.target.value); setInviteError(""); }}
                        placeholder="naiz@email.com"
                        className="flex-1 px-4 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all"
                      />
                      <button
                        onClick={handleInvite}
                        disabled={inviteLoading}
                        className="px-5 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-xl text-sm transition-all disabled:opacity-60 whitespace-nowrap"
                      >
                        {inviteLoading ? "..." : "Урих"}
                      </button>
                    </div>
                  )}
                  {inviteError && <p className="mt-2 text-red-500 text-xs">{inviteError}</p>}
                </div>

                {/* How it works guide - moved before service fees */}
                <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
                  <h3 className="text-lg font-bold text-gray-900 mb-4">🚀 Хэрхэн ажиллах вэ?</h3>
                  <div className="space-y-3">
                    {[
                      { step: "1", icon: "📣", title: "Сошиал хаягаараа сурталчил", desc: "Манай маркетингийн материалыг хуваалцах эсвэл өөрийн контент тавих. Визний мэдээлэл, зөвлөгөө өгснөөр итгэлцэл бий болно." },
                      { step: "2", icon: "🔑", title: "Referral кодоо хэлж өг", desc: "Үйлчлүүлэгч www.dreamvisamgl.com-д онлайнаар захиалга хийхдээ таны кодыг оруулна — 5% хөнгөлөлт авна. Оффист очиж гэрээ хийхдээ ч кодоо хэлэх нь чухал." },
                      { step: "3", icon: "💰", title: "Комисс авах", desc: "Таны кодоор хийсэн захиалга баталгаажсаны дараа урьдчилгааны дүнгийн 5-15% комисс таны данс руу орно." },
                      { step: "4", icon: "📈", title: "Зэрэглэл дэвш", desc: "Борлуулалт нэмэгдэх тусмам Pro, Elite, Premier зэрэглэлд хүрч комиссын хувь өснө." },
                    ].map((s) => (
                      <div key={s.step} className="flex gap-4 p-4 bg-gray-50 rounded-xl border border-gray-100">
                        <div className="w-8 h-8 bg-indigo-600 text-white rounded-full flex items-center justify-center text-sm font-black flex-shrink-0">{s.step}</div>
                        <div>
                          <p className="font-semibold text-gray-900 text-sm">{s.icon} {s.title}</p>
                          <p className="text-xs text-gray-600 mt-0.5 leading-relaxed">{s.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Service Fees - Country/Type Selector */}
                <ServiceFeesSelector />

                {/* Czech Special Product */}
                <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl border border-red-200 p-6 shadow-sm">
                  <div className="flex items-start gap-3 mb-4">
                    <div className="w-10 h-10 bg-red-600 rounded-xl flex items-center justify-center text-white text-lg flex-shrink-0">🇨🇿</div>
                    <div>
                      <div className="flex items-center gap-2 flex-wrap">
                        <h3 className="text-lg font-bold text-gray-900">Чехийн хөдөлмөрийн гэрээ</h3>
                        <span className="bg-red-600 text-white text-xs font-bold px-2 py-0.5 rounded-full">Онцгой бүтээгдэхүүн</span>
                      </div>
                      <p className="text-sm text-gray-600 mt-0.5">Чехийн ажил олгогчтой гэрээ байгуулан Европт хуулийн дагуу ажиллах боломж</p>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
                    <div className="bg-white rounded-xl p-3 border border-red-100">
                      <p className="text-xs text-gray-500 mb-1">Урьдчилгаа</p>
                      <p className="text-base font-black text-red-700">€800</p>
                      <p className="text-xs text-gray-500">Анхны төлбөр</p>
                    </div>
                    <div className="bg-white rounded-xl p-3 border border-red-100">
                      <p className="text-xs text-gray-500 mb-1">Дундах хуваарь</p>
                      <p className="text-base font-black text-red-700">€2,200</p>
                      <p className="text-xs text-gray-500">3 хуваалт</p>
                    </div>
                    <div className="bg-white rounded-xl p-3 border border-red-100">
                      <p className="text-xs text-gray-500 mb-1">Таны комисс</p>
                      <p className="text-base font-black text-red-700">5%</p>
                      <p className="text-xs text-gray-500">Урьдчилгаанаас</p>
                    </div>
                  </div>
                  <div className="bg-red-100 rounded-xl p-3">
                    <p className="text-xs text-red-800 font-medium">⚠️ Онцгой заалт: Комисс зөвхөн урьдчилгааны дүнгээс олгоно. Виз гарсны дараах дүнгээс олгохгүй.</p>
                  </div>
                </div>

                {/* Agent-exclusive news & offers - moved here after invite friend */}
                <div className="bg-gradient-to-br from-purple-50 to-indigo-50 rounded-2xl border border-purple-200 p-6 shadow-sm">
                  <div className="flex items-center gap-2 mb-4">
                    <h3 className="text-lg font-bold text-gray-900">⭐ Зөвхөн агентуудад</h3>
                    <span className="bg-purple-600 text-white text-xs font-bold px-2 py-0.5 rounded-full">Онцгой</span>
                  </div>
                  <div className="space-y-3">
                    <div className="bg-white rounded-xl p-4 border border-purple-100">
                      <div className="flex items-start gap-3">
                        <span className="text-2xl">🎯</span>
                        <div>
                          <p className="font-semibold text-gray-900 text-sm">Онцгой визний санал</p>
                          <p className="text-xs text-gray-600 mt-0.5">Агент болсноор манай шинэ бүтээгдээмжин, тусгай санал, сезоны хямдралыг хамгийн түрүүнд мэдэх давуу эрхтэй болно.</p>
                        </div>
                      </div>
                    </div>
                    <div className="bg-white rounded-xl p-4 border border-purple-100">
                      <div className="flex items-start gap-3">
                        <span className="text-2xl">📚</span>
                        <div>
                          <p className="font-semibold text-gray-900 text-sm">Мэргэжлийн сургалт</p>
                          <p className="text-xs text-gray-600 mt-0.5">Визний мэдлэг, борлуулалтын арга барил, үйлчлүүлэгчтэй харилцах ур чадварыг хөгжүүлэх онлайн сургалтад оролцох боломж.</p>
                        </div>
                      </div>
                    </div>
                    <div className="bg-white rounded-xl p-4 border border-purple-100">
                      <div className="flex items-start gap-3">
                        <span className="text-2xl">💼</span>
                        <div>
                          <p className="font-semibold text-gray-900 text-sm">Ажлын онцгой санал</p>
                          <p className="text-xs text-gray-600 mt-0.5">Гадаадад ажиллах хүсэлтэй хүмүүст зориулсан онцгой ажлын саналуудыг агентуудад урьдчилан мэдэгдэнэ.</p>
                        </div>
                      </div>
                    </div>
                    <div className="bg-purple-100 rounded-xl p-3">
                      <p className="text-xs text-purple-800 font-medium">🔔 Шинэ мэдээллийг хамгийн түрүүнд авахын тулд Telegram группт нэгдэнэ үү:</p>
                      <a href="https://t.me/+zbaTs6bJ0hpkYjMx" target="_blank" rel="noopener noreferrer"
                        className="inline-flex items-center gap-1.5 mt-2 bg-blue-500 hover:bg-blue-600 text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors">
                        📱 Telegram: Агентуудын групп
                      </a>
                    </div>
                  </div>
                </div>

                {/* Contact */}
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl border border-green-200 p-5">
                  <h3 className="font-bold text-gray-900 mb-3">📞 Төв оффистой холбогдох</h3>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <a
                      href="tel:+97680806633"
                      className="flex-1 flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white px-5 py-3.5 rounded-xl font-bold text-sm transition-all shadow-md"
                    >
                      <Phone className="w-5 h-5" />
                      📞 8080-6633 дугаарт залгах
                    </a>
                    <a
                      href="mailto:partner@untdream.com"
                      className="flex-1 flex items-center justify-center gap-2 bg-white border border-green-300 hover:border-green-400 text-green-800 px-5 py-3.5 rounded-xl font-semibold text-sm transition-all"
                    >
                      ✉️ partner@untdream.com
                    </a>
                  </div>
                </div>
              </div>
            )}

            {/* ── COMPANY INTRO ── */}
            {activeSection === "company" && (
              <div className="space-y-8">
                <SectionHeader
                  icon={<Building2 className="w-6 h-6" />}
                  title="Байгууллагын танилцуулга"
                  subtitle="United Dream Mongolia-ийн тухай бүрэн мэдээлэл"
                />

                {/* About card */}
                <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-4">Бидний тухай</h3>
                      <p className="text-gray-700 leading-relaxed mb-4">
                        <strong>United Dream Mongolia</strong> нь 2016 оноос хойш Монгол иргэдэд гадаадын визийн
                        зөвлөгөө, баримт бичгийн бэлтгэл, мэдүүлгийн үйлчилгээ үзүүлж ирсэн мэргэжлийн байгууллага юм.
                      </p>
                      <p className="text-gray-700 leading-relaxed">
                        Бид 2,000 гаруй үйлчлүүлэгчид амжилттай үйлчилж, тэдний гадаадад явах мөрөөдлийг биелүүлэхэд
                        хувь нэмэр оруулсан. Манай баг нь визийн мэдүүлгийн бүх алхамд таны хажууд байна.
                      </p>
                    </div>
                    <div className="space-y-3">
                      {[
                        { icon: <Clock className="w-5 h-5 text-blue-600" />, label: "Туршлага", value: "2016 оноос хойш (10+ жил)" },
                        { icon: <Users className="w-5 h-5 text-blue-600" />, label: "Үйлчлүүлэгч", value: "2,000+ амжилттай" },
                        { icon: <Globe className="w-5 h-5 text-blue-600" />, label: "Хамрах улсууд", value: "АНУ, Австрали, Канад, Чех, Ирланд, Шенген" },
                        { icon: <Building2 className="w-5 h-5 text-blue-600" />, label: "Хаяг", value: "СУИС-ийн урд, Gem Castle 9F, 907 тоот" },
                        { icon: <MessageSquare className="w-5 h-5 text-blue-600" />, label: "Утас", value: "+976 8080-6633" },
                        { icon: <Clock className="w-5 h-5 text-blue-600" />, label: "Цагийн хуваарь", value: "Даваа–Баасан 09:00–18:00, Ням 13:00–17:00" },
                      ].map((item, i) => (
                        <div key={i} className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl">
                          {item.icon}
                          <div>
                            <span className="text-xs text-gray-500">{item.label}</span>
                            <p className="text-sm font-semibold text-gray-900">{item.value}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Visa categories */}
                <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
                  <h3 className="text-lg font-bold text-gray-900 mb-5">Визний ангилал</h3>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    {[
                      {
                        icon: <Plane className="w-6 h-6" />,
                        color: "blue",
                        title: "Аялалын виз",
                        desc: "АНУ B1/B2, Австрали Subclass 600, Канад TRV, Шенген C категори",
                        countries: ["🇺🇸", "🇦🇺", "🇨🇦", "🇪🇺"],
                      },
                      {
                        icon: <GraduationCap className="w-6 h-6" />,
                        color: "green",
                        title: "Оюутны виз",
                        desc: "АНУ F-1, Австрали Subclass 500, Ирланд Study Visa",
                        countries: ["🇺🇸", "🇦🇺", "🇮🇪"],
                      },
                      {
                        icon: <Briefcase className="w-6 h-6" />,
                        color: "amber",
                        title: "Ажлын виз",
                        desc: "Чех урт хугацааны ажлын зөвшөөрөл",
                        countries: ["🇨🇿"],
                      },
                    ].map((cat, i) => (
                      <div
                        key={i}
                        className={`p-4 rounded-xl border ${
                          cat.color === "blue"
                            ? "bg-blue-50 border-blue-200"
                            : cat.color === "green"
                            ? "bg-emerald-50 border-emerald-200"
                            : "bg-amber-50 border-amber-200"
                        }`}
                      >
                        <div
                          className={`w-10 h-10 rounded-xl flex items-center justify-center mb-3 ${
                            cat.color === "blue"
                              ? "bg-blue-600 text-white"
                              : cat.color === "green"
                              ? "bg-emerald-600 text-white"
                              : "bg-amber-600 text-white"
                          }`}
                        >
                          {cat.icon}
                        </div>
                        <h4 className="font-bold text-gray-900 mb-1">{cat.title}</h4>
                        <p className="text-sm text-gray-600 mb-3">{cat.desc}</p>
                        <div className="flex gap-1">
                          {cat.countries.map((flag, j) => (
                            <span key={j} className="text-xl">{flag}</span>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}



            {/* ── VISA BASICS ── */}
            {activeSection === "visa-basics" && (
              <div className="space-y-8">
                <SectionHeader
                  icon={<Globe className="w-6 h-6" />}
                  title="Визний үндсэн ойлголтууд"
                  subtitle="Виз, статус, цагаачлалын ангилал гэж юу вэ?"
                />

                {/* Visa definition */}
                <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
                  <h3 className="text-lg font-bold text-gray-900 mb-5">Виз гэж юу вэ?</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <p className="text-gray-700 leading-relaxed mb-4">
                        <strong>Виз</strong> нь гадаад улсад орох, байх, гарах эрхийг баталгаажуулсан албан ёсны зөвшөөрөл юм.
                        Виз нь паспорт дотор тэмдэглэгдэх эсвэл электрон хэлбэрт байдаг.
                      </p>
                      <p className="text-gray-700 leading-relaxed">
                        Виз нь зөвхөн тухайн улсад <em>орох зөвшөөрөл</em> бөгөөд хилийн шалгалтын үед хилийн цагдаа
                        эцсийн шийдвэр гаргана. Виз байгаа ч орохыг татгалзах боломжтой.
                      </p>
                    </div>
                    <div className="space-y-3">
                      {[
                        { term: "Виз (Visa)", def: "Тухайн улсад орох зөвшөөрлийн тэмдэглэгдэл" },
                        { term: "Статус (Status)", def: "Тухайн улсад хууль ёсоор байх эрхийн ангилал" },
                        { term: "Entry (Орох)", def: "Тухайн улсад физикаар нэвтрэх үйлдэл" },
                        { term: "Duration of Stay", def: "Нэг удаа байж болох хамгийн урт хугацаа" },
                        { term: "Validity", def: "Визийг ашиглаж болох хугацааны хязгаар" },
                      ].map((item, i) => (
                        <div key={i} className="flex gap-3 p-3 bg-gray-50 rounded-xl">
                          <div className="flex-shrink-0">
                            <span className="text-xs font-bold text-blue-600 bg-blue-100 px-2 py-0.5 rounded">
                              {item.term}
                            </span>
                          </div>
                          <p className="text-sm text-gray-700">{item.def}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Immigrant vs Non-immigrant */}
                <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
                  <h3 className="text-lg font-bold text-gray-900 mb-5">Цагаачлалын виз vs Цагаачлалын бус виз</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-purple-50 border border-purple-200 rounded-xl p-5">
                      <div className="flex items-center gap-2 mb-3">
                        <div className="w-8 h-8 bg-purple-600 rounded-lg flex items-center justify-center">
                          <Home className="w-4 h-4 text-white" />
                        </div>
                        <h4 className="font-bold text-purple-900">Цагаачлалын виз (Immigrant Visa)</h4>
                      </div>
                      <p className="text-purple-800 text-sm leading-relaxed mb-3">
                        Тухайн улсад <strong>байнга оршин суух</strong> зорилгоор авдаг виз. Энэ визийг авсан хүн
                        тухайн улсад байнгын оршин суугч болох эрхтэй.
                      </p>
                      <ul className="space-y-1.5">
                        {[
                          "АНУ: Green Card (EB-1, EB-2, EB-3, Family-based)",
                          "Австрали: Permanent Residency (PR)",
                          "Канад: Permanent Residency",
                          "Чех: Байнгын оршин суух (Trvalý pobyt)",
                          "Ирланд: Stamp 4 (байнгын оршин суух)",
                        ].map((item, i) => (
                          <li key={i} className="text-purple-700 text-sm flex items-start gap-2">
                            <CheckCircle2 className="w-4 h-4 flex-shrink-0 mt-0.5" />
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="bg-blue-50 border border-blue-200 rounded-xl p-5">
                      <div className="flex items-center gap-2 mb-3">
                        <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                          <Plane className="w-4 h-4 text-white" />
                        </div>
                        <h4 className="font-bold text-blue-900">Цагаачлалын бус виз (Non-immigrant Visa)</h4>
                      </div>
                      <p className="text-blue-800 text-sm leading-relaxed mb-3">
                        Тухайн улсад <strong>түр хугацаагаар</strong> байх зорилгоор авдаг виз. Аялал, сургалт,
                        ажил гэх мэт тодорхой зорилготой.
                      </p>
                      <ul className="space-y-1.5">
                        {[
                          "АНУ: B1/B2 (аялал), F-1 (сургалт), H-1B (ажил)",
                          "Австрали: Subclass 600 (аялал), 500 (сургалт)",
                          "Канад: TRV (аялал), Study Permit (сургалт)",
                          "Ирланд: Study Visa (сургалт)",
                          "Шенген: C категори (аялал)",
                        ].map((item, i) => (
                          <li key={i} className="text-blue-700 text-sm flex items-start gap-2">
                            <CheckCircle2 className="w-4 h-4 flex-shrink-0 mt-0.5" />
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="mt-5 bg-amber-50 border border-amber-200 rounded-xl p-4">
                    <p className="text-amber-800 text-sm">
                      <strong>Чухал ойлголт:</strong> Манай үйлчилгээ нь голдуу <strong>цагаачлалын бус виз</strong> дээр
                      ажилладаг. Гэхдээ зарим тохиолдолд (Чех ажлын виз, Ирланд сургалтын виз) цагаачлалын замд
                      хүргэж болно.
                    </p>
                  </div>
                </div>

                {/* Status explanation */}
                <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
                  <h3 className="text-lg font-bold text-gray-900 mb-5">Статус гэж юу вэ?</h3>
                  <p className="text-gray-700 leading-relaxed mb-5">
                    Статус нь тухайн улсад байх хууль ёсны ангилал юм. Виз авснаар статус автоматаар олгогддоггүй —
                    хилийн шалгалтын үед статус тодорхойлогдоно.
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {[
                      { flag: "🇺🇸", country: "АНУ", statuses: ["B-2 (жуулчин)", "F-1 (оюутан)", "H-1B (ажилтан)", "J-1 (солилцооны)", "O-1 (онцгой авьяас)"] },
                      { flag: "🇦🇺", country: "Австрали", statuses: ["Tourist (600)", "Student (500)", "Working Holiday (417)", "Skilled Worker (482)", "Permanent Resident"] },
                      { flag: "🇨🇦", country: "Канад", statuses: ["Visitor", "Student", "Worker", "Permanent Resident", "Citizen"] },
                      { flag: "🇮🇪", country: "Ирланд", statuses: ["Stamp 1 (ажил)", "Stamp 2 (сургалт)", "Stamp 3 (хамааралтан)", "Stamp 4 (байнгын)", "Stamp 5 (иргэн)"] },
                      { flag: "🇳🇿", country: "Шинэ Зеланд", statuses: ["Visitor Visa (аялал)", "Student Visa (сургалт)", "Working Holiday Visa", "Resident Visa (байнгын)"] },
                      { flag: "🇨🇿", country: "Чех", statuses: ["Краткосрочный (90 хоног)", "Долгосрочный (1 жил)", "Постоянный (байнгын)", "Гражданство (иргэн)"] },
                      { flag: "🇪🇺", country: "Шенген", statuses: ["C виз (90/180 хоног)", "D виз (урт хугацаа)", "Байнгын оршин суух", "Иргэн"] },
                    ].map((item, i) => (
                      <div key={i} className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                        <div className="flex items-center gap-2 mb-3">
                          <span className="text-2xl">{item.flag}</span>
                          <span className="font-bold text-gray-900">{item.country}</span>
                        </div>
                        <ul className="space-y-1">
                          {item.statuses.map((s, j) => (
                            <li key={j} className="text-sm text-gray-600 flex items-center gap-1.5">
                              <span className="w-1.5 h-1.5 bg-blue-400 rounded-full flex-shrink-0" />
                              {s}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* ── TOOLS ── */}
            {activeSection === "tools" && (
              <div className="space-y-8">
                <SectionHeader
                  icon={<DollarSign className="w-6 h-6" />}
                  title="Визний хураамж, зардал"
                  subtitle="Улс бүрийн визний хураамж болон зардлын тооцоолуур"
                />

                {/* Visa fee table */}
                <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
                  <h3 className="text-lg font-bold text-gray-900 mb-4">💳 Визний хураамж (улс бүрийн)</h3>
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="bg-gray-50">
                          <th className="text-left px-4 py-3 font-semibold text-gray-700 rounded-tl-xl">Улс</th>
                          <th className="text-left px-4 py-3 font-semibold text-gray-700">Визний төрөл</th>
                          <th className="text-left px-4 py-3 font-semibold text-gray-700">Хураамж</th>
                          <th className="text-left px-4 py-3 font-semibold text-gray-700">Гэр бүлийн байдал</th>
                          <th className="text-left px-4 py-3 font-semibold text-gray-700 rounded-tr-xl">Хугацаа</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100">
                        {[
                          { flag: "🇺🇸", country: "АНУ", type: "B-1/B-2 (аялал)", fee: "$185 + bond", family: "Тийм", duration: "1 сар ⚠️ 2026" },
                          { flag: "🇺🇸", country: "АНУ", type: "F-1 (оюутан)", fee: "$185 + SEVIS $350", family: "Тийм", duration: "Сургаль дуусанч" },
                          { flag: "🇦🇺", country: "Австрали", type: "Tourist (600)", fee: "AUD $250", family: "Тийм", duration: "1 жил хүртэл" },
                          { flag: "🇦🇺", country: "Австрали", type: "Student (500)", fee: "AUD $710", family: "Тийм", duration: "Сургаль дуусанч" },
                          { flag: "🇨🇦", country: "Канад", type: "Visitor", fee: "CAD $100", family: "Тийм", duration: "6 сар" },
                          { flag: "🇨🇦", country: "Канад", type: "Student", fee: "CAD $150", family: "Тийм", duration: "Сургаль дуусанч" },
                          { flag: "🇮🇪", country: "Ирланд", type: "Study", fee: "€60", family: "Тийм", duration: "Сургаль дуусанч" },
                          { flag: "🇨🇿", country: "Чех", type: "Дулгосрочный", fee: "€200", family: "Тийм", duration: "1 жил" },
                          { flag: "🇳🇿", country: "Шинэ Зеланд", type: "Visitor Visa", fee: "NZD $246", family: "Тийм", duration: "9 сар хүртэл" },
                          { flag: "🇳🇿", country: "Шинэ Зеланд", type: "Student Visa", fee: "NZD $375", family: "Тийм", duration: "Сургалт дуусанч" },
                          { flag: "🇪🇺", country: "Шенген", type: "C виз", fee: "€90", family: "Тийм (хүүхэд хасаагдана)", duration: "90 хоног" },
                        ].map((row, i) => (
                          <tr key={i} className="hover:bg-gray-50 transition-colors">
                            <td className="px-4 py-3">
                              <span className="mr-2">{row.flag}</span>
                              <span className="font-medium text-gray-900">{row.country}</span>
                            </td>
                            <td className="px-4 py-3 text-gray-600">{row.type}</td>
                            <td className="px-4 py-3 font-semibold text-blue-700">{row.fee}</td>
                            <td className="px-4 py-3">
                              <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                                row.family === "Тийм" ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"
                              }`}>{row.family}</span>
                            </td>
                            <td className="px-4 py-3 text-gray-600">{row.duration}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <p className="text-xs text-gray-400 mt-3">ℹ️ Хураамж хувиралдах боломжтой. Улс бүрийн ямардалтай шалгаарай.</p>
                </div>

                {/* Cost Calculator */}
                <AgentCostCalculator />
              </div>
            )}

            {/* ── PROBABILITY ── */}
            {activeSection === "probability" && (
              <div className="space-y-8">
                <SectionHeader
                  icon={<TrendingUp className="w-6 h-6" />}
                  title="Виз гарах магадлал"
                  subtitle="Үйлчлүүлэгчийн нөхцөлд үндэслэн виз гарах магадлалыг тооцоолно"
                />
                <AgentProbabilityCalc />
              </div>
            )}

            {/* ── VISA DETAILS ── */}
            {activeSection === "visa-details" && (
              <div className="space-y-6">
                <SectionHeader
                  icon={<BookOpen className="w-6 h-6" />}
                  title="Визний дэлгэрэнгүй мэдээлэл"
                  subtitle="Улс бүрийн виз, алхамууд, баримт бичиг, банкны үлдэгдэл"
                />

                {/* Country tabs */}
                <div className="flex flex-wrap gap-2">
                  {VISA_DATA.map((country) => (
                    <button
                      key={country.country}
                      onClick={() => setActiveCountry(country.country)}
                      className={`flex items-center gap-2 px-4 py-2 rounded-xl font-medium text-sm transition-all ${
                        activeCountry === country.country
                          ? "bg-blue-600 text-white shadow-md"
                          : "bg-white border border-gray-200 text-gray-700 hover:border-blue-300 hover:text-blue-700"
                      }`}
                    >
                      <span className="text-lg">{country.flag}</span>
                      {country.country}
                    </button>
                  ))}
                </div>

                {/* Visa cards for selected country */}
                {VISA_DATA.filter((c) => c.country === activeCountry).map((country) => (
                  <div key={country.country} className="space-y-6">
                    {country.visas.map((visa, i) => (
                      <VisaCard key={i} visa={visa} countryFlag={country.flag} />
                    ))}
                  </div>
                ))}
              </div>
            )}
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Disclaimer */}
      <div className="bg-amber-50 border-t-2 border-amber-200 mt-12 py-6">
        <div className="max-w-6xl mx-auto px-4">
          <div className="bg-white rounded-xl border border-amber-200 p-5">
            <p className="text-sm text-amber-900 leading-relaxed">
              <strong>⚠️ Анхаарамж:</strong> Энэхүү хуудасны мэдээлэл, үнэ, хугацаа болон бусад нөхцөлүүд өөрчлөгдөж эсхүл байж болоно. Сүүлийн үейн мэдээллийг авахын түлд манай төв оффистой холбогдоорой.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-white border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-500">
              © 2026 United Dream Mongolia. Зөвхөн affiliate агентуудад зориулсан.
            </p>
            <div className="flex items-center gap-4">
              <a href="/affiliate" className="text-sm text-blue-600 hover:text-blue-700">
                Affiliate хуудас
              </a>
              <a href="/" className="text-sm text-blue-600 hover:text-blue-700">
                Нүүр хуудас
              </a>
              <a href="tel:+97680806633" className="text-sm text-gray-600 hover:text-gray-900">
                📞 8080-6633
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   MAIN EXPORT
═══════════════════════════════════════════════════════════ */
export default function AffiliateTrainingPage() {
  const [email, setEmail] = useState<string | null>(() => {
    return localStorage.getItem("affiliate_training_email");
  });
  const [showTerms, setShowTerms] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  // Check terms acceptance when email is set (login already verified by EmailGate)
  const { data: accessData, isLoading } = trpc.training.checkAccess.useQuery(
    { email: email! },
    { enabled: !!email }
  );

  // Persist email in localStorage
  const handleEmailSuccess = (e: string) => {
    localStorage.setItem("affiliate_training_email", e);
    setEmail(e);
  };

  // When access data loads, determine if terms modal should show
  useEffect(() => {
    if (!accessData) return;
    if (!accessData.hasAccess) {
      // Access revoked - log out
      localStorage.removeItem("affiliate_training_email");
      setEmail(null);
      return;
    }
    if (!accessData.termsAccepted) {
      setShowTerms(true);
    } else {
      setTermsAccepted(true);
    }
  }, [accessData]);

  const handleTermsAccepted = () => {
    setShowTerms(false);
    setTermsAccepted(true);
  };

  const handleTermsClose = () => {
    // If they close without accepting, log them out
    setShowTerms(false);
    localStorage.removeItem("affiliate_training_email");
    setEmail(null);
  };

  // Loading state
  if (email && isLoading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-400 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-blue-200">Нэвтэрч байна...</p>
        </div>
      </div>
    );
  }

  // Not logged in
  if (!email) {
    return <EmailGate onSuccess={handleEmailSuccess} />;
  }

  // Terms modal
  if (showTerms) {
    return (
      <div className="min-h-screen bg-slate-900">
        <TermsModal
          email={email}
          onAccept={handleTermsAccepted}
          onClose={handleTermsClose}
        />
      </div>
    );
  }

  // Terms not yet accepted (edge case)
  if (!termsAccepted) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center shadow-2xl">
          <Shield className="w-12 h-12 text-blue-600 mx-auto mb-4" />
          <h2 className="text-xl font-bold text-gray-900 mb-3">Үйлчилгээний нөхцөл</h2>
          <p className="text-gray-600 mb-6">
            Сургалтын агуулгыг харахын өмнө үйлчилгээний нөхцөлтэй танилцаж зөвшөөрнө үү.
          </p>
          <button
            onClick={() => setShowTerms(true)}
            className="w-full py-3 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition-colors"
          >
            Нөхцөлтэй танилцах
          </button>
        </div>
      </div>
    );
  }

  // Main content
  const handleLogout = () => {
    localStorage.removeItem("affiliate_training_email");
    setEmail(null);
    setTermsAccepted(false);
  };

  return <TrainingContent email={email} onLogout={handleLogout} />;
}
